import linq from 'linq'
import $ from 'jquery';
import { Vue, Prop } from 'vue-property-decorator'
import { ApiResult, request, QueryWrapper } from '@newview/infrastructure'
import baseSelectUi from "@newview/baseselectui-plugin";
import { Guid } from 'guid-typescript';
import CryptoJs from 'crypto-js'
let treeListLevel = 1
import XLSX from 'xlsx'
import { fromJS } from "immutable";
import html2canvas from 'html2canvas';
import { Tools } from "./Tools"

import {
  DicBusinesstypeoptionApi,
  ShortmessagesApi,
  FileinforApi,
  EnterpriseInforApi,
  InstitutioninforApi,
  InstitutioninforelationApi, UsersignatureApi
} from "@newview/system-api";
import { ActivitiServiceApi } from "@newview/activiti-api";
import { ActReFlowApi } from "@newview/basics-v2-api";
import axios from "axios";
import { getOSSClient,getSignatureUrl } from "@newview/tools";

export class BaseVue extends Vue {

  //#region .net  API  定义 用于质保资料和工序报验
  shortmessagesApi: ShortmessagesApi = new ShortmessagesApi()
  fileinforApi: FileinforApi = new FileinforApi();
  enterpriseInforApi: EnterpriseInforApi = new EnterpriseInforApi();
  institutioninforBaseApi: InstitutioninforApi = new InstitutioninforApi();
  institutioninforelationBaseApi: InstitutioninforelationApi = new InstitutioninforelationApi();
  usersignatureBaseApi: UsersignatureApi = new UsersignatureApi()
  //#endregion


  //#region .net  API  定义 用于质保资料和工序报验
  /**
   * 获取SysGuid
   * @param roadSkey 
   * @returns 
   */
  public getSysGuid(roadSkey: string = "") {
    return roadSkey == "" ? sessionStorage.getItem("sysGuid") : roadSkey;
  }

  //#endregion





  //#region API 定义
  private dicbusinesstypeoptionApi: DicBusinesstypeoptionApi = new DicBusinesstypeoptionApi();
  private base_actReFlowApi: ActReFlowApi = new ActReFlowApi();

  public flowApi: ActivitiServiceApi = new ActivitiServiceApi();
  //#endregion

  //#region  定义变量

  /**
   * 静态资源路径
   */
  publicPath: any = process.env.BASE_URL;

  /**
     * 业主类别编码
     */
  public projectClassCode: string = 'yz';
  /**
   * 监理单位类别编码
   */
  public jlClassCode: string = 'jl';
  /**
   * 施工单位类型编码
   */
  public htClassCode: string = 'sg';

  /**
   * 业主类别Id
   */
  public projectNature: number = 13;
  /**
   * 监理单位类别Id
   */
  public jlNature: number = 14;
  /**
   * 施工单位类型Id
   */
  public htNature: number = 15;

  /**
   * Rule 用户Id KEY
   */
  public ruleLoginUserId: string = "@LoginUserId";
  /**
   * Rule 登录用户账号 KEY
   */
  public ruleLoginAccount: string = "@LoginAccount";
  /**
   * Rule 登录用户名 KEY
   */
  public ruleLoginUserName: string = "@LoginUserName";
  /**
   * Rule 当前时间 KEY
   */
  public ruleCurrentTime: string = "@CurrentDate";

  @Prop({ default: () => ({}) }) linkParam!: any;//权限控制
  public Baselinq = linq;//linq 操作对象
  IMWaiter: any = null;//客服信息（幻影模式）
  //#endregion
  basemounted() {  //基类挂载处理（MainManage.vue）
    let waiter = sessionStorage.getItem("SWaiter");
    if (waiter != null) {
      this.IMWaiter = JSON.parse(waiter);
    }
    else {
      this.IMWaiter = null;
    }
  }
  // 工具方法
  Tools = Tools
  // signInfor: any = {
  //   ProjectId: this.$globalData.projectInfo!.Id,
  //   ProjectName: this.$globalData.projectInfo!.SP_Name,
  //   SubSystemId: 0,
  //   UId: this.$globalData.businessInfo!.Id,
  //   UName: this.$globalData.businessInfo!.ShortName,
  //   RootId: (this.$globalData as any).shareRoadInfoes[0].Id,
  //   RootName: (this.$globalData as any).shareRoadInfoes[0].R_Name,
  //   UserId: this.$globalData.localUser.Id,
  //   UserName: this.$globalData.localUser.UserName,
  //   PostId: 1,
  //   Post: "测试岗位"
  // }

  //#region 视图页面方法

  /**
 * 表单验证规则
 * @param type 验证类型 0 手机号 1 身份证
 * @param ruleInfo 自定义验证规则
 * @param text 自定义验证为空字段名称 
 * @param validTipInfo  自定义验证提示信息
 * @returns 
 */
  validForm(type: any = null, ruleInfo: any = null, text: string = '', validTipInfo: string = '') {

    const ruleList = [
      { text: '手机号', info: /^1[3456789]\d{9}$/ },
      { text: '身份证', info: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/ }
    ]
    if (!this.isNull(type)) {
      ruleInfo = ruleList[type].info
      text = this.isNull(text) ? ruleList[type].text : text
      validTipInfo = this.isNull(validTipInfo) ? `${ruleList[type].text}格式不正确！` : validTipInfo
    }
    const validate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(`${text}不能为空`));
      } else if (!ruleInfo.test(value)) {
        callback(validTipInfo);
      } else {
        callback();
      }
    };
    return validate
  }

  /**
   * 获取用户信息
   * @returns
   */
  public getUserInfo() {
    const strUserInfo = sessionStorage.getItem('localUser');
    if (this.isNull(strUserInfo)) {
      return { id: 0 };
    }

    return JSON.parse(strUserInfo as string);
  }

  /**引入js文件
   * @param src
   * @param id
   */
  public createScript(src, id) {
    $("body").append('<script src="' + src + '" id="' + id + '" async="async"></script>')
  }
  getCharacter(chart: string, num: number) {
    chart = chart.toUpperCase();
    let arr: string[] = [];
    //获取A-Z
    for (var i = 0; i < 26; i++) {
      arr.push(String.fromCharCode(65 + i));
    }
    let index = arr.indexOf(chart);
    return arr.splice(index, num);
  }
  /** 移除引入js文件
   * @param id
   */
  public removeScript(id) {
    document.querySelector("body")!.removeChild(document.getElementById(id)!);
  }

  /** 检测浏览器是否安装某个插件
   * @param pluginName 插件名称
   * @returns 硕正报表名称
   */
  public checkPlugins(pluginName) {
    let np = navigator.plugins;
    if (np && np.length) {
      for (let i = 0; i < np.length; i++) {
        if (np[i].name.toLowerCase().indexOf(pluginName.toLowerCase()) != -1)
          return true;
      }
      return false;
    } else {
      // 其他则返回false
      return false;
    }
  }
  /**  获取某元素以浏览器左上角为原点bai的坐标
   * @param obj
   */
  public getPoint(obj) {
    let t = obj.offsetTop; //获取该元素对应父容器的上边距
    let l = obj.offsetLeft; //对应父容器的上边距
    //判断是否有父容器，如果存在则累加其边距
    while (obj == obj.offsetParent) {//等效 obj = obj.offsetParent;while (obj != undefined)
      t += obj.offsetTop; //叠加父容器的上边距
      l += obj.offsetLeft; //叠加父容器的左边距
    }
    return {
      top: t,
      left: l
    }
  }

  /**页面加载遮挡等待
   */
  public load() {
    this.$Loading.config({
      color: '#5cb85c',
      failedColor: '#f0ad4e',
      height: 5
    });
    this.$Loading.start();
  }

  /**  关闭加载遮挡
   */
  public finish() {
    this.$Loading.finish();
  }

  /**  全屏加载loading
   * @param content //提示文字
   */
  public showLoading(content = "正在加载中，请稍候...") {
    this.$Spin['show']({
      render: (h) => {
        return h('div', [
          h('Icon', {
            'class': 'iview-spin-icon-load',
            props: {
              type: 'ios-loading',
              size: 30
            }
          }),
          h('div', content)
        ])
      }
    });
  }
  // 获取两个日期之间的日期
  getdiffdate(stime, etime) { //获取两个日期中间的日期
    //初始化日期列表，数组
    var diffdate = new Array();
    var i = 0;
    //开始日期小于等于结束日期,并循环
    while (stime <= etime) {
      diffdate[i] = stime;

      //获取开始日期时间戳
      var stime_ts = new Date(stime).getTime();
      console.log('当前日期：' + stime + '当前时间戳：' + stime_ts);

      //增加一天时间戳后的日期
      var next_date = stime_ts + (24 * 60 * 60 * 1000);

      //拼接年月日，这里的月份会返回（0-11），所以要+1
      var next_dates_y = new Date(next_date).getFullYear() + '-';
      var next_dates_m = (new Date(next_date).getMonth() + 1 < 10) ? '0' + (new Date(next_date).getMonth() + 1) + '-' : (new Date(next_date).getMonth() + 1) + '-';
      var next_dates_d = (new Date(next_date).getDate() < 10) ? '0' + new Date(next_date).getDate() : new Date(next_date).getDate();

      stime = next_dates_y + next_dates_m + next_dates_d;

      //增加数组key
      i++;
    }
    return diffdate;
  }

  /**  关闭loading
   */
  public closeLoading() {
    this.$Spin["hide"]();
  }

  /**  控制按钮是否按角色配置权限显示
  * @param code:按钮编码（eg:'Add'）(code为'-'时不验证，默认显示)
  * @param operates:string:可以显示的按钮编码集合（eg:'Add','Clear',...）
  */
  public btnIsShow(code, operates) {
    return true;
    if (code == "-" || operates == '-') {
      return true;
    }
    code = code ? code : ''
    let isShow = true
    let operatesObj = this.isNull(operates) ? [] : operates.split(',')
    let operatesArr: any = []
    for (const item of operatesObj) {
      operatesArr.push(item.toLowerCase())
    }
    if ($.inArray(code.toLowerCase(), operatesArr) < 0) {
      isShow = false
    }
    return isShow
  }

  /** 根据Id获取元素
   * @param id
   */
  public Id(id) {
    return document.getElementById(id) as any
  }

  /** 获取vue中的组件对象
   * @param refName
   * @returns
   */
  public ref(refName) {
    return this.$refs[refName] as any;
  }

  /**获取虚拟节点对应的真实DOM */
  public refDom(refName): HTMLElement | undefined {
    if (!this.ref(refName)?.$el) {
      return this.ref(refName)
    }
    return this.ref(refName)!.$el;
  }

  /**  弹出成功消息
   * @param content
   */
  public success(content: string) {
    this.$Message.success(content)
  }

  /** 弹出警告消息
   * @param content
   */
  public warning(content: string) {
    this.$Message.warning(content)
  }

  /**  弹出异常消息
   * @param content
   */
  public error(content: string) {
    this.$Message.error({
      content: content,
      duration: 10,
      closable: true
    })
  }

  /**  消息提示
   * @param content
   * @param type default、success、warning、error
   * @param duration
   */
  tipMessage(content, type = "success", duration = 2) {
    this.$Message.destroy()
    let option: any = {
      background: true,
      content: content,
      duration: duration
    };
    this.$Message[type](option);
  }

  setivewModalZindexMax() {
    setTimeout(() => {
      $(".ivu-modal-mask,.ivu-modal-wrap").css("z-index", this.getMaxZIndex())
    }, 30);
  }
  getMaxZIndex() {
    let maxZ = Math.max.apply(null, $.map($('body *'), (e: any) => {
      if ($(e).css('position') != 'static') {
        return parseInt($(e).css('z-index')) || -1;
      } else {
        return 0
      }
    }
    ));
    return maxZ;
  }
  /**  alert对话框弹出
   * @param content:弹出内容
   * @param okCallback:点击确定回调
   * @param type:弹出样式类型(默认为warning)（可不传）
   * @param title：提示标题(默认为‘提示’)（可不传）
   */
  public alert(content, okCallback?: any, type = "warning", title = "提示") {
    let option: any = {
      title: title,
      content: content,
      onOk: () => {
        if (okCallback) okCallback();
      }
    };
    this.$Modal[type](option);
    this.setivewModalZindexMax()
  }

  /**  confirm对话框弹出
   * @param content:提示内容
   * @param okCallback：确认回调方法
   */
  public confirm(content, okCallback, cancelCallback?: any, okText: string = "确认", cancelText: string = "取消", title: string = '提示') {
    let width = content.length * 14 + 105;  //字数*字号+空白部分的宽
    this.$Modal.confirm({
      title: title,
      content: content,
      okText: okText,
      width: width > 380 ? 380 : (width < 300 ? 300 : width),  //宽度在300~380之间
      cancelText: cancelText,
      onOk: () => {
        okCallback();
      },
      onCancel: () => {
        if (cancelCallback) cancelCallback();
      }
    });
    this.setivewModalZindexMax()
  }

  /** 对话框弹出（自定义，浙江项目暂用）
   * @param content:提示内容
   * @param okCallback：确认回调方法
   * @param CancelCallback：取消回调方法
   */
  public confirmNV(content, okCallback, cancelCallback?: any) {
    // let width = content.length * 14 + 105;  //字数*字号+空白部分的宽
    // width = width > 380 ? 380 : (width < 300 ? 300 : width)  //宽度在300~380之间
    let fff = require("@newview/ui/src/components/confirm.vue")
    const confirmConstructor = Vue.extend(fff.default)
    let confirmEl: any = new confirmConstructor({
      el: document.createElement('div')
    })
    document.body.appendChild(confirmEl.$el)
    confirmEl.content = content
    confirmEl.cancel = function () {
      if (cancelCallback) cancelCallback();
      confirmEl.control = false
    }
    confirmEl.confirm = function () {
      okCallback();
      confirmEl.control = false
    }
    // $("body").append();
  }

  /**  弹出可输入文本的对话框
   * @param placeholder //输入框默认提示语
   * @param title //标题
   * @param okCallback  //点击确认回调(返回输入内容 )
   * @param cancelCallback  //点击取消回调
   * @param width  //弹窗框宽度,可不传(默认：300)
   * @param type  //输入框类型，参考iview文档中Input组件中属性‘type’,可不传(默认：'text')
   * @param defval  //默认显示值
   * @return {type}
   */
  public prompt(placeholder, title, okCallback, cancelCallback: any = null, width: any = 300, type = "text", defval = "") {
    let content = defval;
    this.$Modal.confirm({
      width: width,
      render: (h: any) => {
        return h("div", {}, [
          h("p", { style: "line-height:35px;" }, title),
          h("Input", {
            props: {
              type: type,
              placeholder: placeholder,
              value: defval,
              rows:type=="textarea"?4:undefined
            },
            style: "width:100%",

            on: {
              input: (val) => {
                content = val;
              }
            }
          })
        ]);
      },
      onOk: () => {
        okCallback(content)
      },
      onCancel: () => {
        if (cancelCallback) {
          cancelCallback();
        }
      }
    });
    this.setivewModalZindexMax()
  }
  /**
   * @description: 打开一个消息提示
   * @param {*} title 消息提示标题
   * @param {*} desc  消息提示描述
   * @param {*} type  可选：open、info、success、warning、error
   * @param {*} duration 自动关闭的延时，单位秒，不关闭可以写 0
   * @param {*} name  当前通知的唯一标识
   * @param {*} top  当前通知距页面顶部的高
   * @return {*}
   * @author: pangting
   */
  public NoticeShow(title, desc, type = "open", duration = 5, name = "", top = 80) {
    this.$Notice.config({
      top: top,
    });
    let option = {
      title: title,
      desc: desc,
      name: name,
      duration: duration
    }
    this.$Notice[type](option);
  }
  /**
   * @description: 关闭消息提示
   * @param {*} name 通知的唯一标识   不传则关闭所有
   * @return {*}
   * @author: pangting
   */
  public NoticeClose(name = "") {
    if (name != "") {
      this.$Notice.close(name)
    } else {
      this.$Notice.destroy()
    }
  }
  /** 出发父级（componentName）组件执行（eventName）
   * @param componentName
   * @param eventName
   * @param params
   */
  public dispatch(componentName, eventName, params) {
    let parent: any = this.$parent || this.$root;
    let name = parent.$options.name;
    while (parent && (!name || name !== componentName)) {
      parent = parent.$parent;
      if (parent) {
        name = parent.$options.name;
      }
    }
    if (parent) {
      parent.$emit.apply(parent, ([eventName] as any).concat(params));
    }
  }

  /**
   * @description: 表单验证方法
   * @param {*} formRef 表单组件的ref
   * @return {*} true：验证通过  false：验证失败
   * @author: pangting
   */
  async formValidate(formRef) {
    return new Promise((resolve) => {
      console.log("formRef");
      this.ref(formRef).validate((valid) => {
        if (valid) {
          resolve(true)
        } else {
          resolve(false)
        }
      })
    })

  }

  //#endregion

  //#region 数据生成获取

  /** 生成唯一编码
  */
  public getUniqueCode() {
    let guidStr = Guid.create().toString().replace(/\-/g, '');
    return "nv"+guidStr;
  }


  public getUniqueCode2() {
    let guidStr = Guid.create().toString().replace(/\-/g, '');
    return guidStr;
  }


  /** 生成唯一编码
   * @param a
   * @returns
   */
  public NewGuid() {
    return this.getUniqueCode();
  }

  /**  近似正泰分布的随机数据
   */
  public uniform2NormalDistribution() {
    let sum = 0.0;
    for (let i = 0; i < 12; i++) {
      sum = sum + Math.random();
    }
    return sum - 6.0;
  }

  /** 获取区间随机数
   * @param minNum
   * @param maxNum
   * @returns
   */
  public randomNum(minNum: number, maxNum: number) {
    switch (arguments.length) {
      case 1:
        return parseInt(`${Math.random() * minNum + 1}`, 10);
      case 2:
        return parseInt(`${Math.random() * (maxNum - minNum + 1) + minNum}`, 10);
      default:
        return 0;
    }
  }

  /** 获取区间随机数
   * @param min
   * @param max
   * @returns
   */
  public randomNum2(min, max) {
    return this.randomNum(min, max);
    //Math.floor(Math.random() * (max - min + 1)) + min;
  }
  /**
   * 用于前端JS导入excel 转换读出的excel日期列数据转换
   * @param numb
   * @param format
   * @returns
   */
  ExcelDateConvert(numb) {
    const time = new Date((numb - 1) * 24 * 3600000 + 1);
    time.setFullYear(time.getFullYear() - 70)
    const year = time.getFullYear();
    const month = time.getMonth() + 1;
    const date = time.getDate() - 1;
    return year.toString() + '-' + (month < 10 ? '0' + month : month) + '-' + (date < 10 ? '0' + date : date)
  }


  /** 获取文件URL
   * @param fileId
   * @returns
   */
  public getFileUrl(fileId) {
    let url: string = '';
    let file = this.Id(fileId)
    let agent = navigator.userAgent!
    if (agent.indexOf('MSIE') >= 1) {
      url = file.value
    } else if (agent.indexOf('Firefox') > 0) {
      url = window.URL!.createObjectURL(file.files.item(0))
    } else if (agent.indexOf('Chrome') > 0) {
      url = window.URL!.createObjectURL(file.files.item(0))
    }
    return url
  }



  /**  获取当前登录人所配置的前台BIM菜单数据
   * @param {*}
   * @return {*}
   */
  public loadBIMMenuData() {
    let menuData: any = localStorage.getItem("MainMenuDatas");
    menuData = JSON.parse(menuData)
    console.log(menuData)
    let BIMMenu: any = this.Baselinq.from(menuData).where(item => item["moduleName"] == "BIM应用").toArray()
    if (BIMMenu.length > 0) {
      BIMMenu = BIMMenu[0].children
    }
    let BIMMenuList: any = []
    BIMMenu.forEach((item) => {
      let childList: any = []
      for (const item2 of item.children) {
        let Obj = {
          code: item2["moduleUrl"],
          icon: this.isNull(item2["iconUrl"]) ? null : item2["iconUrl"],
          Id: item2["id"],
          label: item2["moduleName"],
          status: false,
          hasStatus: true,
        }
        if (item2["clickIsCloseParent"]) {
          Obj["clickIsCloseParent"] = item2["clickIsCloseParent"];
        }
        try {
          let AttachParams = JSON.parse(item2.moduleParams)
          for (const key in AttachParams) {
            Obj[key] = AttachParams[key]
          }
          let hasStatus = AttachParams.status == undefined ? (AttachParams.Status == undefined ? true : AttachParams.Status) : AttachParams.status
          Obj.hasStatus = hasStatus
        } catch (error) {

        }
        childList.push(Obj)
      }

      let Obj = {
        code: item["moduleUrl"],
        icon: this.isNull(item["iconUrl"]) ? null : item["iconUrl"],
        Id: item["id"],
        label: item["moduleName"],
        status: false,
        hasStatus: true,
        SubMenus: childList,
      }
      if (childList.length > 0) {
        Obj['isShow'] = true;
      }
      try {
        let AttachParams = JSON.parse(item.moduleParams)
        for (const key in AttachParams) {
          Obj[key] = AttachParams[key]
        }
      } catch (error) {

      }
      BIMMenuList.push(Obj)
    });
    // BIMMenuList.push({// 开发使用
    //     "code": "developer_case",
    //     "icon": null,
    //     "Id": 999,
    //     "label": "开发者",
    //     "status": false,
    //     "hasStatus": false,
    //     "SubMenus": [],
    //     "Status": true,
    //     "iconPath": '<svg style="fill: currentColor;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" ><path d="M896 806.08a32 32 0 0 1 64 0v73.92a48 48 0 0 1-48 48h-800A48 48 0 0 1 64 880v-736A48 48 0 0 1 112 96h800A48 48 0 0 1 960 144v166.144H128V864h768v-57.92z m0-559.936V160H128v86.144h768zM641.92 405.056a32 32 0 0 1 60.16 21.888l-128 352a32 32 0 0 1-60.16-21.888l128-352zM776.192 469.408a32 32 0 0 1 47.616-42.816l126.432 140.64a32 32 0 0 1 0 42.784l-126.432 140.64a32 32 0 1 1-47.616-42.784l107.232-119.232-107.2-119.232zM438.24 469.408a32 32 0 1 0-47.584-42.816l-126.464 140.64a32 32 0 0 0 0 42.784l126.464 140.64a32 32 0 1 0 47.584-42.784l-107.2-119.232 107.2-119.232z"></path></svg>'
    // }) 
    return BIMMenuList
  }

  /** 根据地址使用url 获取数据
   * @param url
   * @returns
   */
  public async $getJson(url, option = {
    method: "GET",
    dataType: "json",
    crossDomain: true,
    cache: false,
    params: {}
  }) {
    return await request(url, option);
  }

  /**  解析Api接口返回数据
   * @param apiResult
   */
  public parseApiResult(apiResult: ApiResult, defaultValue: any = null) {
    if (this.isNull(apiResult)) return null
    if (apiResult.code === 200 && (apiResult.msg == '请求成功' || apiResult.msg == '承载数据为空')) {
      return apiResult.data
    } else {
      if (apiResult.code === 401) {
        this.error("Token过期了，请重新登录！")
        return
      }
      if (!this.isNull(apiResult.msg)) {
        this.error(apiResult.msg)
      } else if (!this.isNull(apiResult.sub_msg)) {
        this.error(apiResult.sub_msg!)
      }
      return defaultValue
    }
  }
  /**  解析Api接口返回数据
  * @param apiResult
  */
  public netParseApiResult(apiResult: ApiResult, defaultValue: any = null) {
    if (this.isNull(apiResult)) return null
    if (apiResult.code === 200) {
      return apiResult.result
    } else {
      if (!this.isNull(apiResult.msg)) {
        this.error(apiResult.msg)
      } else if (!this.isNull(apiResult.sub_msg)) {
        this.error(apiResult.sub_msg!)
      }
      return defaultValue
    }
  }

  /**@url :图片服务器上的url
     * @img :图片url对应的图片
     * */
  toBase64 = (img) => {

    const canvas = document.createElement('canvas');//创建一个canvas元素
    canvas.width = img.width;//把当前url对应的图片的宽度赋予canvas
    canvas.height = img.height;//把当前url对应的图片的高度赋予canvas
    const ctx: any = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);//在画布上一比一的画出img
    const base64 = canvas.toDataURL('image/jpeg');//调用canvas的toDataURL获取.jpg的base64数据
    return base64;
  }
  public getImageUrlBase64 = (url) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';//处理跨域，后端也要设置跨域处理才行
    img.src = url;
    img.onload = () => {
      return this.toBase64(img);
    }
  }

  /**
     * @description: 打开NTKO窗口
     * @param {any} param {Token:"文件token",TempToken:"模板token(无模板可不传)",readOnly:false,taoHongToken:"套红模板token(无模板可不传)"} 
     * @return {*}
     * @author: pangting
     */
  NTKOWindowOpen(param: any = {}) {
    if (!window["ntkoBrowser"].ExtensionInstalled()) {
      this.$Modal.info({
        width: 500,
        closable: false,
        okText: "关闭",
        render: (h: any) => {
          return h('div', {
            style: {
              "padding-top": "30px",
              'text-align': 'center'
            }
          }, [
            h('div', {
              class: '',
              style: `font-size: 17px;color: #929292;margin-bottom: 10px;`
            }, "尚未安装NTKO Web Chrome跨浏览器插件"),
            h('div', {
              class: '',
              style: `border: 2px solid #68acf4;
                            padding: 5px 15px;
                            font-weight: bold;
                            font-size: 16px;
                            border-radius: 4px;
                            display: inline-block;`,
              on: {
                click: () => {
                  window.location.href = "/static/NTKO/NTKO控件安装程序-NewView.exe"
                }
              }
            }, [
              h("Icon", {
                props: {
                  type: "md-download",
                  color: "#68acf4",
                  size: 20
                }
              }),
              h('a', {}, "点击下载安装")
            ])
          ])
        },
        onOk: () => {
        },
        onCancel: () => {
        }
      })
      return
    }
    // param.ProjectSKey = this.$globalData.projectInfo?.SKey
    // window["ntkoBrowser"].openWindow('http://' + window.location.host + '/static/NTKO/html/ntkoEdit.html?param=' + encodeURIComponent(JSON.stringify(param)), false, undefined, undefined, undefined, undefined, undefined, 1200, 900)
    // debugger
    // window.open('http://' + window.location.host + '/static/NTKO/html/ntkoEdit.html?param=' + encodeURIComponent(JSON.stringify(param)))
    // console.log('http://' + window.location.host + '/static/NTKO/html/ntkoEdit.html?param=' + encodeURIComponent(JSON.stringify(param)))
    //alert(JSON.stringify(param))

    if (window.location.protocol === "https:") {
        //console.log("当前页面使用的是HTTPS协议");
        //生产环境htts方式
       window["ntkoBrowser"].openWindow('https://' + window.location.host + '/static/NTKO/html/ntkoEdit.html?param=' + encodeURIComponent(JSON.stringify(param)))
    } else {
        //console.log("当前页面使用的是HTTP协议");
         //本地环境
        window["ntkoBrowser"].openWindow('http://' + window.location.host + '/static/NTKO/html/ntkoEdit.html?param=' + encodeURIComponent(JSON.stringify(param)))
    }


   
    
  }

  /**  获取列表父节点集合
  * @param node :当前节点数据
  * @param AllNodes：列表所有数据
  * @return:
  */
  public getListParents(node, AllNodes) {
    let ans: any = [];
    for (let i = 0; i < AllNodes.length; i++) {
      if (node.PId == AllNodes[i].Id) {
        if (AllNodes[i].Id == 0) {
          return AllNodes[i];
        }
        ans.push(AllNodes[i]);
        return ans.concat(this.getListParents(AllNodes[i], AllNodes));
      }
    }
  }

  /**  获取列表父节点集合
   * @param {*} row         当前行数据
   * @param {*} listData    列表
   * @param {any} pRows     不传
   * @return {*}
   */
  public getAllParentRows(row, listData, pRows: any = []) {
    if (row.PId > 0) {
      let data: any = this.Baselinq.from(listData).where(item => item["Id"] == row.PId).toArray();
      if (data.length > 0) {
        pRows.push(data[0])
        this.getAllParentRows(data[0], listData, pRows)
      }
    }
    return pRows
  }
  /**  java列表父节点集合
 * @param {*} row         当前行数据
 * @param {*} listData    列表
 * @param {any} pRows     不传
 * @return {*}
 */
  public getAllParentRowsJ(row, listData, pRows: any = []) {
    if (row.pid > 0) {
      let data: any = this.Baselinq.from(listData).where(item => item["id"] == row.pid).toArray();
      if (data.length > 0) {
        pRows.push(data[0])
        this.getAllParentRows(data[0], listData, pRows)
      }
    }
    return pRows
  }

  /** 数据位数格式化
   * @param num
   * @param scount
   * @param pad
   * @return {*}
   */
  public LeftPadNumber(num: number, scount: number) {
    let nlen = (num.toString()).length;
    let str = '';
    let i = 0;
    do {
      str += '0'
      ++i;
    } while (i < (scount - nlen))
    str += num.toString();
    return str;
  }

  /**  将数组分为几组
    * @param {*} data 原始数组
    * @param {*} num  几个一组
    * @return {*}
    */
  public arrayGroup(data, num) {
    let newArray: any = []
    for (let i = 0, len = data.length; i < len; i += num) {
      newArray.push(data.slice(i, i + num));
    }
    return newArray
  }
  /**
   * 数组通过Id去重
   * @param arr 
   */
  public duplicateRemoval(arr) {
    let obj = {};
    arr = arr.reduce((newArr, next) => {
      obj[next.id] ? "" : (obj[next.id] = true && newArr.push(next));
      return newArr;
    }, []);
    return arr;
  }
  //度转度°分′秒″
  ToDegrees(val) {
    if (typeof (val) == "undefined" || val == "") {
      return "";
    }
    var i = val.indexOf('.');
    var strDu = i < 0 ? val : val.substring(0, i);//获取度
    var strFen: string = "0";
    var strMiao: any = 0;
    if (i > 0) {
      var strFen = "0" + val.substring(i);
      strFen = Number(strFen) * 60 + "";
      i = strFen.indexOf('.');
      if (i > 0) {
        strMiao = "0" + strFen.substring(i);
        strFen = strFen.substring(0, i);//获取分
        strMiao = strMiao * 60 + "";
        i = strMiao.indexOf('.');
        strMiao = strMiao.substring(0, i + 4);//取到小数点后面三位
        strMiao = parseFloat(strMiao).toFixed(0);//精确小数点后面两位
      }
    }
    return strDu + "°" + strFen + "'" + strMiao + "\"";

  }
  /**
   * 数组通过key去重
   * @param arr 
   */
  public duplicateRemovalKey(arr, key) {
    let obj = {};
    arr = arr.reduce((newArr, next) => {
      obj[next[key]] ? "" : (obj[next[key]] = true && newArr.push(next));
      return newArr;
    }, []);
    return arr;
  }
  /**
   * @description: 数组隔几个取一个数据组成新数组
   * @param {*} arr 源数据
   * @param {*} splitNum  隔几个
   * @return {*}
   * @author: pangting
   */  
  arraySplit(arr:any,splitNum){
    let resultArr:any = [];
    for (let i = 0; i < arr.length; i += splitNum) {
        const sliceResult = arr.slice(i, i + 1);
        if (sliceResult.length > 0) {
            resultArr.push(...sliceResult);
        } else {
            break;
        }
    }
    return resultArr
  }


  public convertImageToCanvas(w, h, text, fontSize = 34, bgColor = "rgb(0,0,0)", textColor = "#f00") {
    let canvas = document.createElement('canvas')
    canvas.width = w
    canvas.height = h
    let context: any = canvas.getContext('2d') // 获取对应的2D对象(画笔)
    context.fillStyle = bgColor // 设置填充的背景颜色
    context.fillRect(0, 0, w, h) // 绘制 w*h 像素的已填充矩形：
    context.fillStyle = textColor
    context.textAlign = 'center'
    context.font = "bold " + fontSize + "px'字体','字体','宋体'" // 设置字体
    context.textBaseline = 'hanging' // 在绘制文本时使用的当前文本基线
    context.fillText(text, w / 2, (h / 2) - 9) // 设置文本内容
    return canvas.toDataURL('image/png')
  }

  //#endregion

  //#region 数据校验

  /**  验证是否为null
   * @param obj
  */
  public isNull(obj) {
    if (obj === '' || obj === null || obj === undefined || obj === 'undefined' || obj === 'null') {
      return true
    }
    return false
  }
  /**
 * 
 * @param numb 数字格式化为财务数字
 * @returns 
 */
  public NumberTofinanceMode(numb: string) {
    if (!numb.toString().includes('.')) {
      numb = numb + ".00";
    }
    return `${numb}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
  /**
   * 财务数字格式化
   * @param value 
   * @returns 
   */
  public financeModeToNumber(value: string) {
    return value.replace(/\￥\s?|(,*)/g, '');
  }
  MoneysmalltoBIG(n) {
    var fraction = ['角', '分'];
    var digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
    var unit = [
      ['元', '万', '亿'],
      ['', '拾', '佰', '仟']
    ];
    var head = n < 0 ? '欠' : '';
    n = Math.abs(n);

    var s = '';

    for (var i = 0; i < fraction.length; i++) {
      s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
    }
    s = s || '整';
    n = Math.floor(n);

    for (var i = 0; i < unit[0].length && n > 0; i++) {
      var p = '';
      for (var j = 0; j < unit[1].length && n > 0; j++) {
        p = digit[n % 10] + unit[1][j] + p;
        n = Math.floor(n / 10);
      }
      s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
    }
    return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整');
  }

  formatAmount(value) {
    //传入值不是数字直接返回0
    if (!value) return '0.00'
    const values = value.toString().split('.')
    // 整数部分
    let integerNum = values[0]
    // 小数部分
    let decimalNum = values[1] ? values[1] : '00'
    decimalNum = decimalNum.length === 1 ? decimalNum + 0 : decimalNum
    //传入值小于1000不切割
    if (integerNum < 1000) {
      return `${integerNum}.${decimalNum}`
    }
    const list = []
    while (integerNum.length > 3) {
      // 倒序切割
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      list.unshift(integerNum.slice(-3));
      integerNum = integerNum.slice(0, -3)
    }
    // 处理剩余长度
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    list.unshift(integerNum)
    return `${list.join(',')}.${decimalNum}`
  }

  //#endregion

  //#region 数据格式转换

  /** 日期时间格式化
   * @param date
   * @param fmt
   * @returns
   */
  public ForMatDate(date, fmt: any = "yyyy-MM-dd") {
    let o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      'S': date.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    for (let k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
    return fmt
  }

  /**
   * 当前时间所处月份
   */
  public getMonth(){
    // 创建一个新的Date对象，它默认包含当前日期和时间
    var now = new Date();

// 获取月份，注意月份是从0开始的
    var month = now.getMonth();

// 将月份加1，使其变为人类可读的格式（1-12）
    var monthFormatted = month + 1;

    return monthFormatted;
  }

  /**
   * 当前时间所处季度
   */
  public getQuarter(){
    // 创建一个新的Date对象，表示当前日期和时间
    var now = new Date();

    // 获取月份（注意：月份是从0开始的）
    var month = now.getMonth();

    // 根据月份判断季度
    var quarter;
    if (month >= 0 && month < 3) {
      quarter = 1; // 第一季度
    } else if (month >= 3 && month < 6) {
      quarter = 2; // 第二季度
    } else if (month >= 6 && month < 9) {
      quarter = 3; // 第三季度
    } else {
      quarter = 4; // 第四季度
    }

    return quarter;
    // 打印季度
    console.log("当前时间处于第" + quarter + "季度");
  }

  public ForMatDateThreeMonth(date, fmt: any = "yyyy-MM-dd") {
    let o = {
      'M+': date.getMonth() + 4, // 月份
      'd+': date.getDate() - 1, // 日
      'h+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      'S': date.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    for (let k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
    return fmt
  }
  formatDateChine(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份是从0开始的
    const day = ('0' + date.getDate()).slice(-2);

    return `${year}年${month}月${day}日`;
  }
  /**|
   * 时间格式(2021-05-19T11:01:23.295)
   * 格式化时间戳 返回(yyyy-MM-dd);
   */
  public FormatTime(time) {
    let d = new Date(time);
    let times = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
    return times
  }

  /**
   * 时间格式(2021-05-19T11:01:23.295)
   * 格式化时间戳 返回(yyyy-MM-dd HH:mm:ss)
   */

  public FormatDateTime(time) {
    return new Date(+new Date(time) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
  }
  /**
     * @description: 将dom元素截图并进行下载
     * @param {*} ref 要截取的元素ref
     * @return {*}
     * @author: pangting
     */
  domToImgDownload(ref, saveName = "图片名") {
    let ele = this.ref(ref)
    html2canvas(ele, {
      backgroundColor: "rgba(0,0,0,0)"
    }).then((canvas) => {
      let url = canvas.toDataURL('image/png');
      console.log(url)
      this.base64ImgDownLoad(url, saveName)
    })
  }
  /**
    * @description: base64图片下载
    * @param {*} base64Code
    * @param {*} saveName
    * @return {*}
    * @author: pangting
    */
  base64ImgDownLoad(base64Code, saveName = "图片名",callback) {
    let base64 = base64Code.toString(); // imgSrc 就是base64哈
    let byteCharacters = atob(
      base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
    );
    let byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    let byteArray = new Uint8Array(byteNumbers);
    let blob = new Blob([byteArray], {
      type: undefined,
    });
    let aLink = document.createElement("a");
    aLink.download = saveName + ".png"; //这里写保存时的图片名称
    aLink.href = URL.createObjectURL(blob);
    aLink.click();
    if (callback) {
      callback()
    }
  }
  async getDomToBase64Img(ele) {
    let canvas = await html2canvas(ele, {
      backgroundColor: "rgba(0,0,0,0)"
    })
    let url = canvas.toDataURL('image/png');
    //   console.log(url)
    return url
  }
   generateRandomNegativeNumber() {
    var positiveNumber = Math.random(); // 生成一个0到1之间的随机正数
    var negativeNumber = positiveNumber * -1; // 将正数乘以-1得到负数
    return negativeNumber;
  }


  /** 图片转64Base大串
   * @param url
   * @param callback
   * @param width
   * @param height
   */
  public getImgToBase64(url, callback, width?: number, height?: number) {
    let canvas: HTMLCanvasElement | null = document.createElement('canvas')
    let ctx = canvas.getContext('2d')
    let img = new Image()
    if (width) {
      img.width = width
    }
    if (height) {
      img.height = height
    }
    img.crossOrigin = 'Anonymous'
    img.style.objectFit = 'fill'
    img.onload = function () {
      canvas!.height = img.height
      canvas!.width = img.width
      ctx!.drawImage(img, 0, 0)
      let dataURL = canvas!.toDataURL('image/png', 0.5)
      callback(dataURL)
      canvas = null
    }
    img.src = url
  }

  // 将File（Blob）对象转变为一个dataURL字符串， 即base64格式
  fileToDataURL(file) {
    return new Promise((resolve) => {
      const reader: any = new FileReader();
      reader.onloadend = (e) => {
        resolve(e.target.result);
      }
      reader.readAsDataURL(file);
    })
  }
  // 将dataURL字符串转变为image对象，即base64转img对象
  dataURLToImage(dataURL) {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.src = dataURL;
    })
  }
  // 将一个canvas对象转变为一个File（Blob）对象
  canvastoFile(canvas, type, quality) {
    return new Promise((resolve) => {
      canvas.toBlob(blob => resolve(blob), type, quality)
    })
  }
  // 图片压缩
  async compress(originfile, maxSize) {
    return new Promise(async (resolve, reject) => {
      const originSize = originfile.size / 1024; // 单位为kb
      console.log('图片指定最大尺寸为', maxSize, '原始尺寸为：', originSize);

      // 将原图片转换成base64
      const base64 = await this.fileToDataURL(originfile);

      // 缩放图片需要的canvas
      const canvas = document.createElement('canvas');
      const context: any = canvas.getContext('2d');

      // 小于maxSize，则不需要压缩，直接返回
      if (originSize < maxSize) {
        resolve({ compressBase64: base64, compressFile: originfile });
        console.log(`图片小于指定大小:${maxSize}KB，不用压缩`);
        return;
      }


      const img: any = await this.dataURLToImage(base64);

      const scale = 1;
      const originWidth = img.width;
      const originHeight = img.height;
      const targetWidth = originWidth * scale;
      const targetHeight = originHeight * scale;

      canvas.width = targetWidth;
      canvas.height = targetHeight;
      context.clearRect(0, 0, targetWidth, targetHeight);
      context.drawImage(img, 0, 0, targetWidth, targetHeight);

      // 将Canvas对象转变为dataURL字符串，即压缩后图片的base64格式
      // const compressedBase64 = canvas.toDataURL('image/jpeg', 0.1);
      // 经过我的对比，通过scale控制图片的拉伸来压缩图片，能够压缩jpg，png等格式的图片
      // 通过canvastoFile方法传递quality来压缩图片，只能压缩jpeg类型的图片，png等格式不支持
      // scale的压缩效果没有canvastoFile好
      // 在压缩到指定大小时，通过scale压缩的图片比通过quality压缩的图片模糊的多
      // 压缩的思路，用二分法找最佳的压缩点
      // 这里为了规避浮点数计算的弊端，将quality转为整数再计算;
      // const preQuality = 100;
      const maxQualitySize = { quality: 100, size: Number.MAX_SAFE_INTEGER };
      const minQualitySize = { quality: 0, size: 0 };
      let quality = 100;
      let count = 0; // 压缩次数
      let compressFinish = false; // 压缩完成
      let invalidDesc = '';
      let compressBlob: any = null;

      // 二分法最多尝试8次即可覆盖全部可能
      while (!compressFinish && count < 12) {
        compressBlob = await this.canvastoFile(canvas, 'image/jpeg', quality / 100);
        const compressSize = compressBlob.size / 1024;
        count++;
        if (compressSize === maxSize) {
          console.log(`压缩完成，总共压缩了${count}次`);
          compressFinish = true;
          return;
        }
        if (compressSize > maxSize) {
          maxQualitySize.quality = quality;
          maxQualitySize.size = compressSize;
        }
        if (compressSize < maxSize) {
          minQualitySize.quality = quality;
          minQualitySize.size = compressSize;
        }
        console.log(`第${count}次压缩,压缩后大小${compressSize},quality参数:${quality}`);

        quality = Math.ceil((maxQualitySize.quality + minQualitySize.quality) / 2);

        if (maxQualitySize.quality - minQualitySize.quality < 2) {
          if (!minQualitySize.size && quality) {
            quality = minQualitySize.quality;
          } else if (!minQualitySize.size && !quality) {
            compressFinish = true;
            invalidDesc = '压缩失败，无法压缩到指定大小';
            console.log(`压缩完成，总共压缩了${count}次`);
          } else if (minQualitySize.size > maxSize) {
            compressFinish = true;
            invalidDesc = '压缩失败，无法压缩到指定大小';
            console.log(`压缩完成，总共压缩了${count}次`);
          } else {
            console.log(`压缩完成，总共压缩了${count}次`);
            compressFinish = true;
            quality = minQualitySize.quality;
          }
        }
      }

      if (invalidDesc) {
        // 压缩失败，则返回原始图片的信息
        console.log(`压缩失败，无法压缩到指定大小：${maxSize}KB`);
        reject({ msg: invalidDesc, compressBase64: base64, compressFile: originfile });
        return;
      }

      compressBlob = await this.canvastoFile(canvas, 'image/jpeg', quality / 100);
      const compressSize = compressBlob.size / 1024;
      console.log(`最后一次压缩（即第${count + 1}次），quality为:${quality}，大小：${compressSize}`);
      const compressedBase64 = await this.fileToDataURL(compressBlob);

      const compressedFile = new File([compressBlob], originfile.name, { type: 'image/jpeg' });

      resolve({ compressFile: compressedFile, compressBase64: compressedBase64 });
    })
  }


  /** 日期加减运存
   * @param date
   * @param days
   * @returns
   */
  public addDate(date, days) {
    if (days == undefined || days == '') {
      days = 1;
    }
    const dateTime = new Date(date);
    dateTime.setDate(dateTime.getDate() + days);
    let month = `${dateTime.getMonth() + 1}`;
    let day = `${dateTime.getDate()}`;
    let mm = "'" + month + "'";
    let dd = "'" + day + "'";
    //单位数前面加0
    if (mm.length == 3) {
      month = "0" + month;
    }
    if (dd.length == 3) {
      day = "0" + day;
    }
    let time = dateTime.getFullYear() + "-" + month + "-" + day
    return time;
  }
  /** 时间计算
   * @param sdata
   * @param edata
   * @param onlyday（H:小时D天M月Y年）
   */
  public TimeCount(sdata, edata, onlyday = 'H') {
    let sddt = new Date(sdata);
    let eddt = new Date(edata);
    let dateDiff = eddt.getTime() - sddt.getTime();//时间差的毫秒数
    let hours = Math.floor(dateDiff / (3600 * 1000))//计算出小时数
    let lhours = hours % 24;
    let years = Math.floor(hours / (24 * 365));
    let monthes = Math.floor((hours - years * 24 * 365) / (30 * 24));
    let days = Math.floor((hours - years * 24 * 365 - monthes * 30 * 24) / 24);
    let text = "";
    if (years > 0) {
      text += years + '年'
    }
    if (monthes > 0) {
      text += monthes + '月'
    }
    if (days > 0 && (onlyday == 'D' || onlyday == 'H')) {
      text += days + '天'
    }
    if (lhours > 0 && onlyday == 'H') {
      text += lhours + '小时'
    }
    return text;
  }
  /** 数据转换 双精度格式（decimal）
   * @param x
   * @returns
   */
  public toDecimal(x) {
    let f = parseFloat(x);
    if (isNaN(f)) {
      return '';
    }
    f = Math.round(x * 100) / 100;
    let s = f.toString();
    let rs = s.indexOf('.');
    if (rs < 0) {
      rs = s.length;
      s += '.';
    }
    while (s.length <= rs + 2) {
      s += '0';
    }
    return s;
  }

  /** json数据集对象深度拷贝合并
   * @param target
   * @param sources
   * @returns
   */
  public assiginObj(target = {}, sources = {}) {
    let obj = target;
    let tmpsource = JSON.stringify(sources);
    let Copyojct = JSON.parse(tmpsource);
    if (typeof target != 'object' || typeof Copyojct != 'object') {
      return Copyojct; // 如果其中一个不是对象 就返回sources
    }
    for (let key in Copyojct) {
      // 如果target也存在 那就再次合并
      if (target.hasOwnProperty(key)) {
        obj[key] = this.assiginObj(target[key], Copyojct[key]);
      } else {
        // 不存在就直接添加
        obj[key] = Copyojct[key];
      }
    }
    return obj;
  }
  /**
   * @description: 深度拷贝对象
   * @param {*} obj
   * @return {*}
   * @author: pangting
   */
  deepClone(obj) {
    // 特判null
    if (obj == null) {
      return null
    }
    // 基本数据类型：number\string\boolean\undefined
    if (typeof obj != 'object') {
      return obj
    }
    // 特判RegExp 和 Date
    if (obj instanceof RegExp || obj instanceof Date) {
      return obj
    }
    // 包装类：String/Boolean/Number/自定义
    if (obj.constructor != 'Array' && obj.constructor != 'Object') {
      return obj
    }
    // 数组or对象
    let cloneObj = (obj instanceof Array) ? [] : {}
    for (let item in obj) {
      cloneObj[item] = this.deepClone(obj[item])
    }
    return cloneObj
  }
  /**
   * @description: 深度拷贝对象
   * @param {*} obj
   * @return {*}
   * @author: pangting
   */
  deepCloneObj(obj) {
    return JSON.parse(JSON.stringify(obj))
  }

  
  /**
   * @description: 合并对象或数据
   * @param {*} target
   * @param {array} arg
   * @return {*}
   * @author: pangting
  */
  public merge(target, ...arg) {
    let isObject = (obj)=> {
      return Object.prototype.toString.call(obj) === '[object Object]'
    }
    let isArray = (arr)=> {
      return Array.isArray(arr)
    }
    return arg.reduce((acc, cur) => {
      return Object.keys(cur).reduce((subAcc, key) => {
        const srcVal = cur[key]
        if (isObject(srcVal)) {
          subAcc[key] = this.merge(subAcc[key] ? subAcc[key] : {}, srcVal)
        } else if (isArray(srcVal)) {
          // series: []，下层数组直接赋值
          subAcc[key] = srcVal.map((item, idx) => {
            if (isObject(item)) {
              const curAccVal = subAcc[key] ? subAcc[key] : []
              return this.merge(curAccVal[idx] ? curAccVal[idx] : {}, item)
            } else {
              return item
            }
          })
        } else {
          subAcc[key] = srcVal
        }
        return subAcc
      }, acc)
    }, target)
  }

  /** 字符串首字母大写
 * @param type
 * @returns
 */
  public toUpperCase(str) {
    return str.toUpperCase();
  }
  /** 字符串首字母大写
   * @param type
   * @returns
   */
  public toUpperCaseFirst(type) {
    return type.charAt(0).toUpperCase() + type.slice(1);
  }
  public moneyToNumFiled(str) {
    let num = this.isNull(str) ? "" : str.toString().trim();
    let ss = num.toString();
    if (ss.length == 0) {
      return "";
    }
    num = new Number(ss.replace(/,/g, ""));
    return num;
  }
  public numToMoneyField(num) {
    num = num.toFixed(2);
    num = parseFloat(num)
    num = num.toLocaleString();
    return num;
  }
  /**
   * 依据里程桩号实际值转显示值 eg.(50.30转k50+30)
   */
  public getMeilestonForValue(meile: string, prefix: string = "K") {
    let ret = "";
    if (!this.isNull(meile)) {
      let s_arr = meile.toString().split('.');
      let s_last: any = this.isNull(s_arr[1]) ? "000" : s_arr[1];
      s_last = s_last != "000" ? s_last * 100 : s_last;
      ret = prefix + s_arr[0] + "+" + s_last;
    }
    return ret;
  }
  /**
   *
   * @param Milestone 里程桩号转实际值
   * @returns
   */
  public getMilestoneValue(Milestone: string) {
    let s_arr = Milestone.split('+');
    let s_Klm = s_arr[0].match(/\d+(.\d+)?/g);
    let s_LM = s_arr[1];
    let sm = (Number(s_Klm) * 1000 + Number(s_LM));
    return sm;
  }
  /**
   * //计算中心里程桩号和长度
   * @param S_Milestone
   * @param E_Milestone
   * @returns
   */
  public getMilestone(S_Milestone: string, E_Milestone: string) {
    let m_list: any = { M_Milestone: "", M_length: 0 };
    try {
      let s_arr = S_Milestone.split('+');
      let s_Klm = s_arr[0].match(/\d+(.\d+)?/g);
      let kname = s_arr[0].match(/[a-z]/ig)!.join("");
      let s_LM = s_arr[1];
      let e_arr = E_Milestone.split('+');
      let e_Klm = e_arr[0].match(/\d+(.\d+)?/g);
      let e_LM = e_arr[1];
      let sm = (Number(s_Klm) * 1000 + Number(s_LM));
      let em = (Number(e_Klm) * 1000 + Number(e_LM));
      if (sm < em) {
        let m_klm: any = Math.floor(((em - sm) / 2 + sm) / 1000);
        let m_LM: any = parseFloat(Math.abs(((em - sm) / 2 + sm) % 1000).toString()).toFixed(2);
        m_list.M_Milestone = kname + m_klm + "+" + m_LM;
        m_list.M_length = em - sm;
      }
      return m_list;
    } catch (error) {
      return m_list;
    }
  }

  /**
   * @description: 获取时间差
   * @param {*} d1    //被减时间
   * @param {any} d2  //不传默认为当前时间
   * @return {*}
   * @author: pangting
   */
  public getTimeDifference(d1, d2: any = null) {
    let date1 = new Date(d1).getTime();
    let date2 = d2 ? new Date(d2).getTime() : new Date().getTime();
    let year1 = new Date(d1).getFullYear();
    let year2 = d2 ? new Date(d2).getFullYear() : new Date().getFullYear();
    return {
      year: year2 - year1,
      day: ((date2 - date1) / (24 * 60 * 60 * 1000)).toFixed(0)
    }
  }

  //#endregion

  //#region  复杂数据体处理

  /** 递归组织TreeViewData
   * @param pid
   * @param datas
   */
  private TviewrecursionChild(pid: number, datas: any[], ShowName: string = "NodeName", isUseClass: boolean = true, isExpanded = true) {
    const childDatas = linq
      .from(datas)
      .where(x => x.PId === pid)
      .orderBy(p => p.OrderNo)
      .toArray()
    if (childDatas.length > 0) {
      for (let data of childDatas) {
        data.expanded = isExpanded
        if (data[ShowName] != null) {// by msh
          data.Name = data[ShowName]
        }
        data.items = this.TviewrecursionChild(data.Id, datas, ShowName, isUseClass)
        if (isUseClass) {
          data.spriteCssClass =
            data.items === undefined ||
              data.items == null ||
              data.items.length <= 0
              ? 'fa fa-file-text-o'
              : 'fa fa-folder-o'
        }
      }
    }
    return childDatas
  }


  /** 递归组织TreeViewData
   * @param pid
   * @param datas
   */
  private TviewrecursionChildV2(pid: number, datas: any[], ShowName: string = "NodeName", isUseClass: boolean = true, isExpanded = true) {
    const childDatas = linq
      .from(datas)
      .where(x => x.PId === pid)
      .orderBy(p => p.OrderNo)
      .toArray()
    if (childDatas.length > 0) {
      for (let data of childDatas) {
        data.expanded = isExpanded
        if (data[ShowName] != null) {// by msh
          data.Name = data[ShowName]
        }
        data.items = this.TviewrecursionChildV2(data.Id, datas, ShowName, isUseClass)
        if (isUseClass) {
          data.spriteCssClass =
            data.DocumentType == 1 ? 'fa fa-folder-o' : 'fa fa-file-text-o';
        }
      }
    }
    return childDatas
  }


  /**
   * @description: 组装TrwwView所需数据
   * @param {any} datas  生成tree的列表数据
   * @param {string} ShowName  展示文本对应的key
   * @param {boolean} isUseClass 列表前图标
   * @param {*} PId  顶级PId
   * @param {*} isExpanded 节点是否展开
   * @return {*}
   * @author: pangting
   */
  public getTreeviewData(datas: any[], ShowName: string = "NodeName", isUseClass: boolean = true, PId = 0, isExpanded = true) {
    const treeDatas = linq
      .from(datas)
      .where(x => x.PId === PId)
      .orderBy(p => p.OrderNo)
      .toArray()
    for (let data of treeDatas) {
      data.expanded = isExpanded
      if (data[ShowName] != null) {// by msh
        data.Name = data[ShowName]
      }
      if (isUseClass) data.spriteCssClass = 'fa fa-folder-o';
      data.items = this.TviewrecursionChild(data.Id, datas, ShowName, isUseClass, isExpanded)
    }
    return treeDatas
  }


  /**
   * @description: 组装TrwwView所需数据
   * @param {any} datas  生成tree的列表数据
   * @param {string} ShowName  展示文本对应的key
   * @param {boolean} isUseClass 列表前图标
   * @param {*} PId  顶级PId
   * @param {*} isExpanded 节点是否展开
   * @return {*}
   * @author: pangting
   */
  public getTreeviewDataV2(datas: any[], ShowName: string = "NodeName", isUseClass: boolean = true, PId = 0, isExpanded = true) {
    const treeDatas = linq
      .from(datas)
      .where(x => x.PId === PId)
      .orderBy(p => p.OrderNo)
      .toArray()
    for (let data of treeDatas) {
      data.expanded = isExpanded
      if (data[ShowName] != null) {// by msh
        data.Name = data[ShowName]
      }
      data.spriteCssClass = data.DocumentType == 1 ? 'fa fa-folder-o' : 'fa fa-file-text-o';
      data.items = this.TviewrecursionChildV2(data.Id, datas, ShowName, isUseClass, isExpanded)
    }
    return treeDatas
  }

  /**
   * 加载数据
   * 将没有父节点的ParentId设置为0，处理TreeList不能绑定的问题
   * @param datas
   */
  public handlingDatas(datas: any[], idName: string, pIdName: string) {
    const linqDatas = linq.from(datas);
    for (let i = 0; i < datas.length; i++) {
      const item = datas[i];
      if (linqDatas.count(d => d[idName] === item[pIdName]) <= 0) {
        item[pIdName] = 0;
      }
    }
  }

  /**
   * 定制获取Treeview数据体
   * @param datas
   * @param idName
   * @param pIdName
   * @param textName
   * @param catalogIcon
   * @param leafIcon
   * @param isExpanded
   * @returns
   */
  public getTreeviewDataCustom(datas: any[], idName: string, pIdName: string, textName: string, catalogIcon: string = "fa fa-folder-o", leafIcon: string = "fa fa-file-text-o", isExpanded = true) {
    this.handlingDatas(datas, idName, pIdName);
    const linqData = linq.from(datas);
    const getChilds = (pId: number) => {
      const childDatas = linqData.where(x => x[pIdName] === pId).toArray()
      if (childDatas.length > 0) {
        for (let data of childDatas) {
          data.expanded = isExpanded
          if (data[textName] != null) {
            data.Name = data[textName]
          }
          data.items = getChilds(data[idName])
          data.spriteCssClass = data.items === undefined || data.items == null || data.items.length <= 0 ? leafIcon : catalogIcon;
        }
      }
      return childDatas
    };

    const treeDatas = getChilds(0);
    return treeDatas
  }

  /**  组装TrwwView所需数据java
   * @param datas
   */
  public getTreeviewDataJ(datas: any[], PId = 0, ShowName: string = "NodeName", PIdFiled: string = "pId", OrderFiled: string = "id", isUseClass: boolean = true, isExpanded = true) {
    const treeDatas = linq
      .from(datas)
      .where(x => x[PIdFiled] === PId)
      .orderBy(p => p[OrderFiled])
      .toArray()
    console.log('2', treeDatas)
    console.log('3', PIdFiled)
    for (let data of treeDatas) {
      if (data.orderNo == 1 && data.packageName != undefined) {
        data.expanded = true
      } else {
        data.expanded = isExpanded
      }
      if (data[ShowName] != null) {// by msh
        data.Name = data[ShowName]
      }
      if (isUseClass) data.spriteCssClass = 'fa fa-folder-o';
      if (data.institutionNature && data.provinceWithinOutside) {
        if (data.institutionNature == 1 && data.nodeLevel == 1) {
          data.spriteCssClass = 'province';
        }
        else if (data.institutionNature == 1 && data.nodeLevel == 2) {
          data.spriteCssClass = 'city';
        }
        else if (data.institutionNature == 1 && data.nodeLevel == 3) {
          data.spriteCssClass = 'district';
        }
      }
      data.items = this.TviewrecursionChildJ(data.id, datas, ShowName, PIdFiled, OrderFiled, isUseClass, isExpanded, { branchId: data[PIdFiled] })
      data.items = this.TviewrecursionChildJ(data.id, datas, ShowName, PIdFiled, OrderFiled, isUseClass, isExpanded, { branchId: data[PIdFiled] })
    }
    return treeDatas
  }
  /** 递归组织TreeViewData java
* @param pid
* @param datas
*/
  private TviewrecursionChildJ(pid: number, datas: any[], ShowName: string = "NodeName", PIdFiled: string = "pId", OrderFiled: string = "id", isUseClass: boolean = true, isExpanded = true, param: any = {}) {
    const Datas = linq
      .from(datas)
      .where(x => x[PIdFiled] === pid)
      .orderBy(p => p[OrderFiled])
      .toArray()

    let childDatas: any = [];
    Datas.map(e => {
      if (e.branchId && e.branchId != 0) {
        if (param.branchId === e.branchId) childDatas.push(e);
      } else {
        childDatas.push(e);
      }
    })

    if (childDatas.length > 0) {
      for (let data of childDatas) {
        data.expanded = true
        if (data[ShowName] != null) {// by msh
          data.Name = data[ShowName]
        }
        param.branchId = data[PIdFiled];
        data.items = this.TviewrecursionChildJ(data.id, datas, ShowName, PIdFiled, OrderFiled, isUseClass, isExpanded, param)
        if (isUseClass) {
          data.spriteCssClass =
            data.items === undefined ||
              data.items == null ||
              data.items.length <= 0
              ? 'fa fa-file-text-o'
              : 'fa fa-folder-o'
        }
        if (data.institutionNature && data.provinceWithinOutside) {
          if (data.institutionNature == 1 && data.nodeLevel == 1) {
            data.spriteCssClass = 'province';
          }
          else if (data.institutionNature == 1 && data.nodeLevel == 2) {
            data.spriteCssClass = 'city';
          }
          else if (data.institutionNature == 1 && data.nodeLevel == 3) {
            data.spriteCssClass = 'district';
          }
          else if (data.institutionNature == 3 && data.provinceWithinOutside == 1) {
            data.spriteCssClass = 'ingrade';
          }
          else {
            data.spriteCssClass = 'outgrade';
          }
        }
      }
    }
    return childDatas
  }

  /** 组织treeview拖拽数据，可以直接用户接口返回
 * @param treeView treeview控件
 * @param e dragend事件参数
 */
  public getDragOrderParams(treeView, e) {
    const dropPosition = e.dropPosition
    let destinationNodeId = 0;
    let destinationNodePId = 0;
    let destinationData = treeView.dataItem(e.destinationNode);
    if (destinationData === undefined) {
      destinationNodeId = 0
      destinationNodePId = 0
    } else {
      destinationNodeId = destinationData.id
      destinationNodePId =
        dropPosition === 'over' ? destinationData.id : destinationData.pid
    }
    const sourceNodeData = treeView.dataItem(e.sourceNode)
    return {
      destinationNodeId: destinationNodeId,
      destinationNodePId: destinationNodePId,
      dropPosition: dropPosition,
      sourceNodeId: sourceNodeData.id,
      parent: destinationData,
      current: sourceNodeData
    }
  }

  /** C# 递归组装GridTree数据
 * @param pid
 * @param datas
 */
  private TlistRecursionChild(pid: number, datas: any[], isShowChildren: boolean = false, callback: any = undefined, allData: any[] = []) {
    let children: any[] = []
    const childDatas = linq
      .from(datas)
      .where(x => x.PId === pid)
      .orderBy(p => p.OrderNo)
      .toArray()
    if (childDatas.length > 0) {
      treeListLevel++
      for (let data of childDatas) {
        allData.push(data);
        const tempDatas = this.TlistRecursionChild(data.Id, datas, isShowChildren, callback, allData)
        data.TepId = data.Id
        data.children = tempDatas
        data._treeLevel = treeListLevel
        data._disabled = false
        data._showChildren = data._showChildren ? data._showChildren : (isShowChildren ? isShowChildren : false)
        children.push(data)
        if (callback) {
          callback(data);
        }
      }
    }
    return children
  }

  /** C# 组装GridTree所需数据
   * @param datas
   */
  public getTreeListData(datas: any[], isShowChildren: boolean = false, PId = 0, callback: any = undefined, allData: any[] = []) {
    let topLevelDatas = linq
      .from(datas)
      .where(x => x.PId === null || x.PId === PId)
      // .orderBy(p => p.OrderNo)
      .toArray()
    for (let data of topLevelDatas) {
      allData.push(data);
      const tempDatas = this.TlistRecursionChild(data.Id, datas, isShowChildren, callback, allData)
      data.children = tempDatas
      this.$set(data, "childrenCount", tempDatas.length);
      data._treeLevel = 1
      data._disabled = false
      data._showChildren = data._showChildren ? data._showChildren : (isShowChildren ? isShowChildren : false)
      treeListLevel = 1
      if (callback) {
        callback(data);
      }
    }
    return topLevelDatas
  }

  /** C# 组装GridTree所需数据
   * @param datas
   */
  public getTreeListDataJJ(datas: any[], isShowChildren: boolean = false, PId = 0, callback: any = undefined, allData: any[] = [], key = "Id") {
    let topLevelDatas = linq
        .from(datas)
        .where(x => x.PId === null || x.PId === PId)
        .orderBy(p => p.OrderNo)
        .toArray()
    for (let data of topLevelDatas) {
        allData.push(data);
        const tempDatas = this.TlistRecursionChildJJ(data[key], datas, isShowChildren, callback, allData, key)
        data.children = tempDatas
        this.$set(data, "childrenCount", tempDatas.length);
        data._treeLevel = 1
        data._disabled = false
        data._showChildren = data._showChildren ? data._showChildren : (isShowChildren ? isShowChildren : false)
        treeListLevel = 1
        if (callback) {
            callback(data);
        }
    }
    return topLevelDatas
  }

  /** C# 递归组装GridTree数据
 * @param pid
 * @param datas
 */
  private TlistRecursionChildJJ(pid: number, datas: any[], isShowChildren: boolean = false, callback: any = undefined, allData: any[] = [], key = "Id") {
    let children: any[] = []
    const childDatas = linq
        .from(datas)
        .where(x => x.PId === pid)
        .orderBy(p => p.OrderNo)
        .toArray()
    if (childDatas.length > 0) {
        treeListLevel++
        for (let data of childDatas) {
            allData.push(data);
            const tempDatas = this.TlistRecursionChildJJ(data[key], datas, isShowChildren, callback, allData, key)
            data.TepId = data[key]
            data.children = tempDatas
            data._treeLevel = treeListLevel
            data._disabled = false
            data._showChildren = data._showChildren ? data._showChildren : (isShowChildren ? isShowChildren : false)
            children.push(data)
            if (callback) {
                callback(data);
            }
        }
    }
    return children
  }

  /** java  递归组装GridTree数据
     * @param pid
     * @param datas
     */
  private TlistRecursionChildJ(pid: number, datas: any[], isShowChildren: boolean = false, PIdField: string = "pId", OrderFiled: string = "orderNo") {
    let children: any[] = []
    const childDatas = linq
      .from(datas)
      .where(x => x[PIdField] === pid)
      .orderBy(p => p[OrderFiled])
      .toArray()
    if (childDatas.length > 0) {
      treeListLevel++
      for (let data of childDatas) {
        const tempDatas = this.TlistRecursionChildJ(data.id, datas, isShowChildren, PIdField, OrderFiled)
        data.TepId = data.Id
        data.children = data.hasChild == 0 ? [] : (tempDatas.length > 0 ? tempDatas : [null]);
        data._treeLevel = treeListLevel
        data._disabled = false
        data._showChildren = data._showChildren ? data._showChildren : (isShowChildren ? isShowChildren : false)
        children.push(data)
      }
    }
    return children
  }

  /** C#  递归组装VxeGridTree数据
     * @param pid
     * @param datas
     */
  private TlistRecursionChildTree(pid: number, datas: any[], isShowChildren: boolean = false, PIdField: string = "pId", OrderFiled: string = "orderNo") {
    let children: any[] = []
    const childDatas = linq
      .from(datas)
      .where(x => x[PIdField] === pid)
      .orderBy(p => p[OrderFiled])
      .toArray()
    if (childDatas.length > 0) {
      treeListLevel++
      for (let data of childDatas) {
        const tempDatas = this.TlistRecursionChildTree(data.Id, datas, isShowChildren, PIdField, OrderFiled)
        data.TepId = data.Id
        data.children = tempDatas
        data._treeLevel = treeListLevel
        data._disabled = false
        data._showChildren = data._showChildren ? data._showChildren : (isShowChildren ? isShowChildren : false)
        children.push(data)
      }
    }
    return children
  }
  /**
   * 同getIViewTreeData调用
   * 可通过改变返回值list直接映射改变tree相关属性，便于直接改变某个子元素而不用递归查找子元素
   * 返回值tree数组提供expandPTree方法，直接调用展开所有父元素
   * 返回值tree数组提供parent属性，映射父级元素
   * @param datas
   * @param keyName
   * @param param
   * @param PId
   * @param IdKey
   * @param PIdKey
   * @returns
   * 结果返回{list:原始数组,tree使用的数组}
   */
  public getIViewTreeDataUp(datas: any[], keyName: string = "Name", param: any = {}, PId = 0, IdKey = "Id", PIdKey = "PId") {
    let tempObj: {
      list: any[],
      tree: any[]
    } = {
      list: datas,
      tree: []
    }
    for (let index = 0; index < tempObj.list.length; index++) {
      let element = tempObj.list[index];
      if (element[PIdKey] == PId) {
        tempObj.tree.push(element)
      }
      if (!this.isNull(param.expand)) {
        element.expand = param.expand;
      } else {
        element.expand = true;
      }
      element.contextmenu = param.contextmenu
      element.title = element[keyName];
      if (!this.isNull(param.CId)) {
        element.disabled = param.CId.toString().indexOf(element.CId) > -1 ? false : true;
      }
      element.parent = tempObj.list.find(x => x.Id == element.PId)
      element.expandPTree = (flg: boolean = true, isChild: boolean = true) => {
        if (!isChild) {
          element.expand = flg;
        }
        if (!this.isNull(element.parent))
          element.parent.expandPTree(flg, false);
      }
      element.children = this.IviewTviewrecursionChildUp(element[IdKey], keyName, param, IdKey, PIdKey, element, tempObj);
    }
    return tempObj;
  }
  private IviewTviewrecursionChildUp(pid: number, keyName: string = "Name", param, IdKey = "Id", PIdKey = "PId", parent: any = undefined, tobj: any = undefined) {
    let templs = tobj.list.filter(x => x.PId == pid);
    templs.forEach(data => {
      if (!this.isNull(param.expand)) {
        if (param.NodeLevel && data.NodeLevel) {
          if (param.NodeLevel >= data.NodeLevel) {
            data.expand = true;
          } else {
            data.expand = false;
          }
        } else
          data.expand = param.expand;
      } else {
        data.expand = true;
      }
      data.contextmenu = param.contextmenu
      data.title = data[keyName];
      if (!this.isNull(param.CId)) {
        data.disabled = param.CId.toString().indexOf(data.CId) > -1 ? false : true;
      }
      data.parent = parent;
      data.children = this.IviewTviewrecursionChildUp(data[IdKey], keyName, param, IdKey, PIdKey, data, tobj);
      data.expandPTree = (flg: boolean = true, isChild: boolean = true) => {
        if (!isChild) {
          data.expand = flg;
        }
        if (!this.isNull(data.parent))
          data.parent.expandPTree(flg, false);
      }
    })

    return templs
  }

  /**java组装vxegrid
   * 组装GridTree所需数据
   * @param datas
  */

  public getTreeListDataJ(datas: any[], isShowChildren: boolean = false, pId = 0, PIdField: string = "pId", OrderFiled: string = "orderNo") {
    let topLevelDatas = linq
      .from(datas)
      .where(x => x[PIdField] === null || x[PIdField] === pId)
      .orderBy(p => p[OrderFiled])
      .toArray()
    for (let data of topLevelDatas) {
      const tempDatas = this.TlistRecursionChildJ(data.id, datas, isShowChildren, PIdField, OrderFiled)
      data.children = data.hasChild == 0 ? [] : (tempDatas.length > 0 ? tempDatas : [null]);
      data._treeLevel = 1
      data._disabled = false
      data._showChildren = data._showChildren ? data._showChildren : (isShowChildren ? isShowChildren : false)
      treeListLevel = 1
    }
    return topLevelDatas
  }

  /**C#组装vxegrid
   * 组装GridTree所需数据
   * @param datas
  */
  public getTreeListDataTree(datas: any[], isShowChildren: boolean = false, pId = 0, PIdField: string = "Pid", OrderFiled: string = "Id") {
    let topLevelDatas = linq
      .from(datas)
      .where(x => x[PIdField] === null || x[PIdField] === pId)
      .orderBy(p => p[OrderFiled])
      .toArray()
    for (let data of topLevelDatas) {
      const tempDatas = this.TlistRecursionChildTree(data.Id, datas, isShowChildren, PIdField, OrderFiled)
      data.children = tempDatas
      data._treeLevel = 1
      data._disabled = false
      data._showChildren = data._showChildren ? data._showChildren : (isShowChildren ? isShowChildren : false)
      treeListLevel = 1
    }
    return topLevelDatas
  }

  /**  递归组织iview tree数据
   * @param pid
   * @param datas
   */
  private IviewTviewrecursionChild(pid: number, datas: any[], keyName: string = "Name", param) {
    const childDatas = linq
      .from(datas)
      .where(x => x.PId === pid)
      .orderBy(p => p.OrderNo)
      .toArray()
    if (childDatas.length > 0) {
      for (let data of childDatas) {
        if (!this.isNull(param.expand)) {
          data.expand = param.expand;
        }
        else {
          data.expand = true;
        }
        data.title = data[keyName];
        if (!this.isNull(param.CId)) {
          data.disabled = param.CId.toString().indexOf(data.CId) > -1 ? false : true;
        }
        data.children = this.IviewTviewrecursionChild(data.Id, datas, keyName, param);
      }
    }
    return childDatas
  }

  /**  组装iview Tree所需数据
   * @param datas
   */
  public getIViewTreeData(datas: any[], keyName: string = "Name", param: any = {}) {
    const treeDatas = linq
      .from(datas)
      .where(x => x.PId === 0)
      .orderBy(p => p.OrderNo)
      .toArray()
    for (let data of treeDatas) {
      if (!this.isNull(param.expand)) {
        data.expand = param.expand;
      }
      else {
        data.expand = true;
      }
      data.title = data[keyName];
      if (!this.isNull(param.CId)) {
        data.disabled = param.CId.toString().indexOf(data.CId) > -1 ? false : true;
      }
      data.children = this.IviewTviewrecursionChild(data.Id, datas, keyName, param);
    }
    return treeDatas
  }

  /**  递归组织iview Cascader级联选择器数据(赵鑫)
   * @param pid
   * @param datas
   */
  private IViewCascadercursionChild(pid: number, datas: any[], keyName: string = "Name", KeyValue = "Id") {
    const childDatas = linq
      .from(datas)
      .where(x => x.PId === pid)
      .orderBy(p => p.OrderNo)
      .toArray()
    if (childDatas.length > 0) {
      for (let data of childDatas) {
        data.value = this.isNull(data[KeyValue]) ? "" : data[KeyValue].toString()
        data.label = data[keyName]
        data.children = this.IViewCascadercursionChild(data.Id, datas, keyName, KeyValue)

      }
    }
    return childDatas
  }

  /**  组装iview Cascader级联选择器所需数据(赵鑫)
   * @param datas
   */
  public getIViewCascaderData(datas: any[], keyName: string = "Name", KeyValue = "Id") {
    const treeDatas = linq
      .from(datas)
      .where(x => x.PId === 0)
      .orderBy(p => p.OrderNo)
      .toArray()
    for (let data of treeDatas) {
      data.expand = true
      data.value = this.isNull(data[KeyValue]) ? "" : data[KeyValue].toString()
      data.label = data[keyName]
      data.children = this.IViewCascadercursionChild(data.Id, datas, keyName, KeyValue)
    }
    return treeDatas
  }



  //#endregion


  //#region  坐标转换
  public LngLatConvert = {
    out_of_china(lng, lat) {
      return (lng < 72.004 || lng > 137.8347) || ((lat < 0.8293 || lat > 55.8271) || false)
    },
    transformlat(lng, lat) {
      const x_PI = 3.14159265358979324 * 3000.0 / 180.0
      const PI = 3.1415926535897932384626
      const a = 6378245.0
      const ee = 0.00669342162296594323
      let ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(
        lng))
      ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0
      ret += (20.0 * Math.sin(lat * PI) + 40.0 * Math.sin(lat / 3.0 * PI)) * 2.0 / 3.0
      ret += (160.0 * Math.sin(lat / 12.0 * PI) + 320 * Math.sin(lat * PI / 30.0)) * 2.0 / 3.0
      return ret
    },
    transformlng(lng, lat) {
      const x_PI = 3.14159265358979324 * 3000.0 / 180.0
      const PI = 3.1415926535897932384626
      const a = 6378245.0
      const ee = 0.00669342162296594323
      let ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng))
      ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0
      ret += (20.0 * Math.sin(lng * PI) + 40.0 * Math.sin(lng / 3.0 * PI)) * 2.0 / 3.0
      ret += (150.0 * Math.sin(lng / 12.0 * PI) + 300.0 * Math.sin(lng / 30.0 * PI)) * 2.0 / 3.0
      return ret
    },
    /**
     * WGS-84 转 GC-J02火星
     * @param longitude 经度
     * @param latitude 纬度
     * @returns 
     */
    // WGS84_TO_GCJ02(longitude: number, latitude: number): { longitude: number, latitude: number } {
    //   let lng = longitude
    //   let lat = latitude
    //   if (this.out_of_china(lng, lat)) {
    //     console.log('国外')
    //     return { longitude: lng, latitude: lat }
    //   }
    //   //定义一些常量
    //   //GCJ02 转换为 WGS84
    //   const x_PI = 3.14159265358979324 * 3000.0 / 180.0
    //   const PI = 3.1415926535897932384626
    //   const a = 6378245.0
    //   const ee = 0.00669342162296594323
    //   let dlat = this.transformlat(lng - 105.0, lat - 35.0)
    //   let dlng = this.transformlng(lng - 105.0, lat - 35.0)
    //   let radlat = lat / 180.0 * PI
    //   let magic = Math.sin(radlat)
    //   magic = 1 - ee * magic * magic
    //   let sqrtmagic = Math.sqrt(magic)
    //   dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtmagic) * PI)
    //   dlng = (dlng * 180.0) / (a / sqrtmagic * Math.cos(radlat) * PI)
    //   var mglat = lat + dlat
    //   var mglng = lng + dlng
    //   return {
    //     longitude: mglng,
    //     latitude: mglat,
    //   }
    // },

    WGS84_TO_GCJ02(longitude: number, latitude: number,isNvMap=false) {
      function out_of_china(lng, lat) {
          return (lng < 72.004 || lng > 137.8347) || ((lat < 0.8293 || lat > 55.8271) || false)
      }

      function transformlat(lng, lat) {
          const x_PI = 3.14159265358979324 * 3000.0 / 180.0
          const PI = 3.1415926535897932384626
          const a = 6378245.0
          const ee = 0.00669342162296594323
          let ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(
              lng))
          ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0
          ret += (20.0 * Math.sin(lat * PI) + 40.0 * Math.sin(lat / 3.0 * PI)) * 2.0 / 3.0
          ret += (160.0 * Math.sin(lat / 12.0 * PI) + 320 * Math.sin(lat * PI / 30.0)) * 2.0 / 3.0
          return ret
      }

      function transformlng(lng, lat) {
          const x_PI = 3.14159265358979324 * 3000.0 / 180.0
          const PI = 3.1415926535897932384626
          const a = 6378245.0
          const ee = 0.00669342162296594323
          let ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng))
          ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0
          ret += (20.0 * Math.sin(lng * PI) + 40.0 * Math.sin(lng / 3.0 * PI)) * 2.0 / 3.0
          ret += (150.0 * Math.sin(lng / 12.0 * PI) + 300.0 * Math.sin(lng / 30.0 * PI)) * 2.0 / 3.0
          return ret
      }
      let lng = longitude
      let lat = latitude
      if (out_of_china(lng, lat)) {
          console.log('国外')
          return { longitude: lng, latitude: lat }
      }
      //定义一些常量
      //GCJ02 转换为 WGS84
      const x_PI = 3.14159265358979324 * 3000.0 / 180.0
      const PI = 3.1415926535897932384626
      const a = 6378245.0
      const ee = 0.00669342162296594323
      let dlat = transformlat(lng - 105.0, lat - 35.0)
      let dlng = transformlng(lng - 105.0, lat - 35.0)
      let radlat = lat / 180.0 * PI
      let magic = Math.sin(radlat)
      magic = 1 - ee * magic * magic
      let sqrtmagic = Math.sqrt(magic)
      dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtmagic) * PI)
      dlng = (dlng * 180.0) / (a / sqrtmagic * Math.cos(radlat) * PI)
      var mglat: number = lat + dlat
      var mglng: number = lng + dlng
      if(isNvMap){                
          return {
              lng: mglng,
              lat: mglat,
          }
      }else{
          return {
              longitude: mglng,
              latitude: mglat,
          }
      }
    },


    /**
     * 将百度坐标转变成火星坐标
     *
     * @param longitude 百度坐标系经度
     * @param latitude 百度坐标系纬度
     * @return 火星坐标(高德、腾讯地图等)
     */
    BD09_TO_GCJ02(longitude: number, latitude: number): { longitude: number, latitude: number } {
      var x_pi = 3.14159265358979324 * 3000.0 / 180.0;
      var x = longitude - 0.0065, y = latitude - 0.006;
      var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
      var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
      return {
        longitude: z * Math.cos(theta),
        latitude: z * Math.sin(theta)
      }
    },

    /**
     *  GC-J02（高德） 转 WGS-84
     * @param longitude 经度
     * @param latitude 纬度
     * @returns 
     */
    GCJ02_TO_WGS84(longitude: number, latitude: number): { longitude: number, latitude: number } {
      let lng = longitude
      let lat = latitude
      if (this.out_of_china(lng, lat)) {
        return { longitude: lng, latitude: lat }
      }
      else {
        const x_PI = 3.14159265358979324 * 3000.0 / 180.0
        const PI = 3.1415926535897932384626
        const a = 6378245.0
        const ee = 0.00669342162296594323
        var dlat = this.transformlat(lng - 105.0, lat - 35.0);
        var dlng = this.transformlng(lng - 105.0, lat - 35.0);
        var radlat = lat / 180.0 * PI;
        var magic = Math.sin(radlat);
        magic = 1 - ee * magic * magic;
        var sqrtmagic = Math.sqrt(magic);
        dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtmagic) * PI);
        dlng = (dlng * 180.0) / (a / sqrtmagic * Math.cos(radlat) * PI);
        let mglat = lat + dlat;
        let mglng = lng + dlng;
        return {
          longitude: lng * 2 - mglng,
          latitude: lat * 2 - mglat,
        }
      }
    }
  }




  //#endregion

  //#region  数据加密

  /** Base64加密解密
  */
  base64EncodeChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  base64DecodeChars = new Array(-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
    -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
    -1, -1, -1, -1, -1, -1, -1, 62, -1, -1, -1, 63, 52, 53, 54, 55, 56, 57,
    58, 59, 60, 61, -1, -1, -1, -1, -1, -1, -1, 0, 1, 2, 3, 4, 5, 6,
    7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,
    25, -1, -1, -1, -1, -1, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36,
    37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, -1, -1, -1,
    -1, -1);

  /**  base64字符串加密
     * @param str
     * @returns
     */
  public base64encode(str) {
    if (this.isNull(str) == true)
      return "";
    let out, i, len;
    let c1, c2, c3;
    len = str.length;
    i = 0;
    out = "";
    while (i < len) {
      c1 = str.charCodeAt(i++) & 0xff;
      if (i == len) {
        out += this.base64EncodeChars.charAt(c1 >> 2);
        out += this.base64EncodeChars.charAt((c1 & 0x3) << 4);
        out += "==";
        break
      }
      c2 = str.charCodeAt(i++);
      if (i == len) {
        out += this.base64EncodeChars.charAt(c1 >> 2);
        out += this.base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
        out += this.base64EncodeChars.charAt((c2 & 0xF) << 2);
        out += "=";
        break
      }
      c3 = str.charCodeAt(i++);
      out += this.base64EncodeChars.charAt(c1 >> 2);
      out += this.base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
      out += this.base64EncodeChars.charAt(((c2 & 0xF) << 2) | ((c3 & 0xC0) >> 6));
      out += this.base64EncodeChars.charAt(c3 & 0x3F)
    }
    return out
  }

  /** base64字符串解密
   * @param str
   * @returns
   */
  public base64decode(str) {
    if (this.isNull(str) == true)
      return "";
    let c1, c2, c3, c4;
    let i, len, out;
    len = str.length;
    i = 0;
    out = "";
    while (i < len) {
      do {
        c1 = this.base64DecodeChars[str.charCodeAt(i++) & 0xff]
      } while (i < len && c1 == -1);
      if (c1 == -1) break;
      do {
        c2 = this.base64DecodeChars[str.charCodeAt(i++) & 0xff]
      } while (i < len && c2 == -1);
      if (c2 == -1)
        break;
      out += String.fromCharCode((c1 << 2) | ((c2 & 0x30) >> 4));
      do {
        c3 = str.charCodeAt(i++) & 0xff;
        if (c3 == 61) return out;
        c3 = this.base64DecodeChars[c3]
      } while (i < len && c3 == -1);
      if (c3 == -1) break;
      out += String.fromCharCode(((c2 & 0XF) << 4) | ((c3 & 0x3C) >> 2));
      do {
        c4 = str.charCodeAt(i++) & 0xff;
        if (c4 == 61) return out;
        c4 = this.base64DecodeChars[c4]
      } while (i < len && c4 == -1);
      if (c4 == -1) break;
      out += String.fromCharCode(((c3 & 0x03) << 6) | c4)
    }
    return out
  }
  /**
   * @description: utf16to8
   * @param {*} str
   * @return {*}
   * @author: pangting
   */
  utf16to8(str) {
    let out, i, len, c;

    out = "";
    len = str.length;
    for (i = 0; i < len; i++) {
      c = str.charCodeAt(i);
      if ((c >= 0x0001) && (c <= 0x007F)) {
        out += str.charAt(i);
      } else if (c > 0x07FF) {
        out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F));
        out += String.fromCharCode(0x80 | ((c >> 6) & 0x3F));
        out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
      } else {
        out += String.fromCharCode(0xC0 | ((c >> 6) & 0x1F));
        out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
      }
    }
    return out;
  }
  /**
   * @description: utf8to16
   * @param {*} str
   * @return {*}
   * @author: pangting
   */
  utf8to16(str) {
    let out, i, len, c;
    let char2, char3;

    out = "";
    len = str.length;
    i = 0;
    while (i < len) {
      c = str.charCodeAt(i++);
      switch (c >> 4) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
          // 0xxxxxxx
          out += str.charAt(i - 1);
          break;
        case 12:
        case 13:
          // 110x xxxx   10xx xxxx
          char2 = str.charCodeAt(i++);
          out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F));
          break;
        case 14:
          // 1110 xxxx  10xx xxxx  10xx xxxx
          char2 = str.charCodeAt(i++);
          char3 = str.charCodeAt(i++);
          out += String.fromCharCode(((c & 0x0F) << 12) |
            ((char2 & 0x3F) << 6) |
            ((char3 & 0x3F) << 0));
          break;
      }
    }

    return out;
  }

  
  /**
   * @description: 十六进制颜色转rgba
   * @param {*} hex
   * @param {*} opacity
   * @return {*}
   * @author: pangting
   */
  hexToRgba(hex, opacity) {
    return 'rgba(' + parseInt('0x' + hex.slice(1, 3)) + ',' + parseInt('0x' + hex.slice(3, 5)) + ',' + parseInt('0x' + hex.slice(5, 7)) + ',' + opacity + ')'
  }
  //#endregion

  //#region 网络日志记录
  /**
   * 通过自定义字符串进行日志跟踪
   * @param itemString
   */
  public setVisitInfoByStringItem(itemString) {
    const menuInfo = JSON.parse(itemString);
    if (menuInfo.userData) {

    }
  }

  //#endregion


  /**  组装TrwwView所需数据java
   * 请大家不要修改这个
   * @param datas
   */
  public getTreeviewDataJysk(datas: any[], ShowName: string = "NodeName", isUseClass: boolean = true, PId = 0, isExpanded = true) {
    const treeDatas = linq
      .from(datas)
      .where(x => x.pId === PId)
      .toArray()
    for (let data of treeDatas) {
      data.expanded = isExpanded
      if (data[ShowName] != null) {// by msh
        data.Name = data[ShowName]
      }
      if (isUseClass) data.spriteCssClass = 'fa fa-folder-o';
      data.items = this.TviewrecursionChildJysk(data.id, datas, ShowName, isUseClass, isExpanded)
    }
    return treeDatas
  }
  /** 递归组织TreeViewData java
  * @param pid
  * @param datas
  */
  private TviewrecursionChildJysk(pid: number, datas: any[], ShowName: string = "NodeName", isUseClass: boolean = true, isExpanded = true) {
    const childDatas = linq
      .from(datas)
      .where(x => x.pId === pid)
      .toArray()
    if (childDatas.length > 0) {
      for (let data of childDatas) {
        data.expanded = isExpanded
        if (data[ShowName] != null) {// by msh
          data.Name = data[ShowName]
        }
        data.items = this.TviewrecursionChildJysk(data.id, datas, ShowName, isUseClass, isExpanded)
        if (isUseClass) {
          data.spriteCssClass =
            data.items === undefined ||
              data.items == null ||
              data.items.length <= 0
              ? 'fa fa-file-text-o'
              : 'fa fa-folder-o'
        }
      }
    }
    return childDatas
  }


  /**
  * 加密
  */
  encrypt(word) {
    let key = CryptoJs.enc.Utf8.parse("d2140707ca3a469c8527e546fe961276");
    let srcs = CryptoJs.enc.Utf8.parse(word);
    let encrypted = CryptoJs.AES.encrypt(srcs, key, {
      mode: CryptoJs.mode.ECB,
      padding: CryptoJs.pad.Pkcs7
    });
    return encrypted.toString();
  }

  /**
   * 解密
   */
  decrypt(word) {
    let key = CryptoJs.enc.Utf8.parse("d2140707ca3a469c8527e546fe961276");
    let decrypt = CryptoJs.AES.decrypt(word, key, {
      mode: CryptoJs.mode.ECB,
      padding: CryptoJs.pad.Pkcs7
    });
    return CryptoJs.enc.Utf8.stringify(decrypt).toString();
  }

  /**  递归组织iview tree数据
  * @param pid
  * @param datas
  */
  private IviewTviewrecursionChildJ(pid: number, datas: any[], keyName: string = "Name", param) {
    const Datas = linq
      .from(datas)
      .where(x => x.pid === pid)
      .orderBy(p => p.orderNo)
      .toArray();

    let childDatas: any = [];
    Datas.map(e => {
      if (e.branchId && e.branchId != 0) {
        if (param.branchId === e.branchId) childDatas.push(e);
      } else {
        childDatas.push(e);
      }
    })

    if (childDatas.length > 0) {
      for (let data of childDatas) {
        if (!this.isNull(param.expand)) {
          data.expand = param.expand;
        }
        else {
          data.expand = true;
        }
        data.title = data[keyName];
        if (!this.isNull(param.CId)) {
          data.disabled = param.CId.toString().indexOf(data.CId) > -1 ? false : true;
        }
        param.branchId = data.pid;
        data.children = this.IviewTviewrecursionChildJ(data.id, datas, keyName, param);
      }
    }
    return childDatas
  }

  /**  组装iview Tree所需数据
   * @param datas
   */
  public getIViewTreeDataJ(datas: any[], keyName: string = "Name", param: any = {}) {
    const treeDatas = linq
      .from(datas)
      .where(x => x.pid === 0)
      .orderBy(p => p.orderNo)
      .toArray()
    for (let data of treeDatas) {
      if (!this.isNull(param.expand)) {
        data.expand = param.expand;
      }
      else {
        data.expand = true;
      }
      data.title = data[keyName];
      if (!this.isNull(param.CId)) {
        data.disabled = param.CId.toString().indexOf(data.CId) > -1 ? false : true;
      }
      param.branchId = data.pid;
      data.children = this.IviewTviewrecursionChildJ(data.id, datas, keyName, param);
    }
    return treeDatas
  }


  /**java组装vxegrid
   * 组装GridTree所需数据
   * @param datas
  */

  public getTreeListDataJ1(datas: any[], isShowChildren: boolean = false, pId = 0, PIdField: string = "pId", OrderFiled: string = "orderNo") {
    let topLevelDatas = linq
      .from(datas)
      .where(x => x[PIdField] === null || x[PIdField] === pId)
      .orderBy(p => p[OrderFiled])
      .toArray()
    for (let data of topLevelDatas) {
      const tempDatas = this.TlistRecursionChildJ(data.id, datas, isShowChildren, PIdField, OrderFiled)
      data.children = data.hasChild == 0 ? [] : (tempDatas.length > 0 ? tempDatas : []);
      data._treeLevel = 1
      data._disabled = false
      data._showChildren = data._showChildren ? data._showChildren : (isShowChildren ? isShowChildren : false)
      treeListLevel = 1
    }
    return topLevelDatas
  }
  /** java  递归组装GridTree数据
    * @param pid
    * @param datas
    */
  private TlistRecursionChildJ1(pid: number, datas: any[], isShowChildren: boolean = false, PIdField: string = "pId", OrderFiled: string = "orderNo") {
    let children: any[] = []
    const childDatas = linq
      .from(datas)
      .where(x => x[PIdField] === pid)
      .orderBy(p => p[OrderFiled])
      .toArray()
    if (childDatas.length > 0) {
      treeListLevel++
      for (let data of childDatas) {
        const tempDatas = this.TlistRecursionChildJ1(data.typeId, datas, isShowChildren, PIdField, OrderFiled)
        data.TepId = data.Id
        data.children = tempDatas
        data._treeLevel = treeListLevel
        data._disabled = false
        data._showChildren = data._showChildren ? data._showChildren : (isShowChildren ? isShowChildren : false)
        children.push(data)
      }
    }
    return children
  }





  /**  组装iview Tree所需数据      特殊处理 内业管理系统使用
   * @param datas
   */
  public getIViewTreeDataJ1(datas: any[], keyName: string = "Name", param: any = {}, key: string = "pid") {

    const treeDatas = linq
      .from(datas)
      .where(x => x[key] === 0)
      .orderBy(p => p.orderNo)
      .toArray()
    for (let data of treeDatas) {
      if (!this.isNull(param.expand)) {
        data.expand = param.expand;
      }
      else {
        data.expand = true;
      }
      data.title = data[keyName];
      if (!this.isNull(param.CId)) {
        data.disabled = param.CId.toString().indexOf(data.CId) > -1 ? false : true;
      }
      data.children = this.IviewTviewrecursionChildJ1(data.typeId, datas, keyName, param, key);
    }
    return treeDatas
  }

  /**  递归组织iview tree数据
* @param pid
* @param datas
*/
  private IviewTviewrecursionChildJ1(pid: number, datas: any[], keyName: string = "Name", param, key) {
    const childDatas = linq
      .from(datas)
      .where(x => x[key] === pid)
      .orderBy(p => p.orderNo)
      .toArray()
    if (childDatas.length > 0) {
      for (let data of childDatas) {
        if (!this.isNull(param.expand)) {
          data.expand = param.expand;
        }
        else {
          data.expand = true;
        }
        data.title = data[keyName];
        if (!this.isNull(param.CId)) {
          data.disabled = param.CId.toString().indexOf(data.CId) > -1 ? false : true;
        }
        data.children = this.IviewTviewrecursionChildJ1(data.typeId, datas, keyName, param, key);
      }
    }
    return childDatas
  }



  /**  组装TrwwView所需数据java
   * @param datas
   */
  public getTreeviewDataJ1(datas: any[], PId = 0, ShowName: string = "NodeName", PIdFiled: string = "pId", OrderFiled: string = "id", isUseClass: boolean = true, isExpanded = true) {
    const treeDatas = linq
      .from(datas)
      .where(x => x[PIdFiled] === PId)
      .orderBy(p => p[OrderFiled])
      .toArray()
    for (let data of treeDatas) {
      data.expanded = isExpanded
      if (data[ShowName] != null) {// by msh
        data.Name = data[ShowName]
      }
      if (isUseClass) data.spriteCssClass = 'fa fa-folder-o';
      if (data.institutionNature && data.provinceWithinOutside) {
        if (data.institutionNature == 1 && data.nodeLevel == 1) {
          data.spriteCssClass = 'province';
        }
        else if (data.institutionNature == 1 && data.nodeLevel == 2) {
          data.spriteCssClass = 'city';
        }
        else if (data.institutionNature == 1 && data.nodeLevel == 3) {
          data.spriteCssClass = 'district';
        }
      }
      data.items = this.TviewrecursionChildJ1(data.typeId, datas, ShowName, PIdFiled, OrderFiled, isUseClass, isExpanded)
      data.items = this.TviewrecursionChildJ1(data.typeId, datas, ShowName, PIdFiled, OrderFiled, isUseClass, isExpanded)
    }
    return treeDatas
  }
  /** 递归组织TreeViewData java
* @param pid
* @param datas
*/
  private TviewrecursionChildJ1(pid: number, datas: any[], ShowName: string = "NodeName", PIdFiled: string = "pId", OrderFiled: string = "id", isUseClass: boolean = true, isExpanded = true) {
    const childDatas = linq
      .from(datas)
      .where(x => x[PIdFiled] === pid)
      .orderBy(p => p[OrderFiled])
      .toArray()
    if (childDatas.length > 0) {
      for (let data of childDatas) {
        data.expanded = isExpanded
        if (data[ShowName] != null) {// by msh
          data.Name = data[ShowName]
        }
        data.items = this.TviewrecursionChildJ1(data.typeId, datas, ShowName, PIdFiled, OrderFiled, isUseClass, isExpanded)
        if (isUseClass) {
          data.spriteCssClass =
            data.items === undefined ||
              data.items == null ||
              data.items.length <= 0
              ? 'fa fa-file-text-o'
              : 'fa fa-folder-o'
        }
        if (data.institutionNature && data.provinceWithinOutside) {
          if (data.institutionNature == 1 && data.nodeLevel == 1) {
            data.spriteCssClass = 'province';
          }
          else if (data.institutionNature == 1 && data.nodeLevel == 2) {
            data.spriteCssClass = 'city';
          }
          else if (data.institutionNature == 1 && data.nodeLevel == 3) {
            data.spriteCssClass = 'district';
          }
          else if (data.institutionNature == 3 && data.provinceWithinOutside == 1) {
            data.spriteCssClass = 'ingrade';
          }
          else {
            data.spriteCssClass = 'outgrade';
          }
        }
      }
    }
    return childDatas
  }


  getCellWidth(value) {
    // 判断是否为null或undefined
    if (value == null) {
      return 10
    } else if (/.*[\u4e00-\u9fa5]+.*$/.test(value)) {
      // 判断是否包含中文
      return value.toString().length * 2.1
    } else {
      return value.toString().length * 1.1
    }
  }
  // Excel导出 （自适应宽度）
  exportTo(
    data: any = [],
    dataType = 'json',
    saveFile = true,
    fileName = '',
    fitWidth = true,
  ) {
    try {
      if (!XLSX) throw 'exportTo: the plug-in "XLSX" is undefined.'
      if (!data || data.length === 0) throw 'exportTo: data is null or undefined.'

      let wb = XLSX.utils.book_new()
      for (const iterator of data) {
        let sheet: any = {}
        switch (dataType) {
          case 'json':
            sheet = XLSX.utils.json_to_sheet(iterator.data)

            if (fitWidth) {
              let colWidths: any = [],
                colNames = Object.keys(iterator.data[0]) // 所有列的名称数组

              // 计算每一列的所有单元格宽度
              // 先遍历行
              iterator.data.forEach((row) => {
                // 列序号
                let index = 0
                // 遍历列
                for (const key in row) {
                  if (colWidths[index] == null) colWidths[index] = []

                  switch (typeof row[key]) {
                    case 'string':
                    case 'number':
                    case 'boolean':
                      colWidths[index].push(this.getCellWidth(row[key]))
                      break
                    case 'object':
                    case 'function':
                      colWidths[index].push(0)
                      break
                  }
                  index++
                }
              })

              sheet['!cols'] = []
              // 每一列取最大值最为列宽
              colWidths.forEach((widths, index) => {
                // 计算列头的宽度
                widths.push(this.getCellWidth(colNames[index]))
                // 设置最大值为列宽
                sheet['!cols'].push({ wch: Math.max(...widths) })
              })
            }
            break
          case 'aoe':
            // 未实现
            sheet = []
            break
        }
        XLSX.utils.book_append_sheet(wb, sheet, iterator.day)
      }
      if (saveFile) {
        XLSX.writeFile(wb, fileName)
        return true
      } else {
        return false;
      }
    } catch (error) {
      console.error('exportTo: ', error)
      throw error
    }
  }

  /**  组装iview Tree所需数据
 * @param datas
 */
  public getIViewTreeDataPId(datas: any[], keyName: string = "Name", param: any = {}) {
    const treeDatas = linq
      .from(datas)
      .where(x => x.PId === 0)
      .orderBy(p => p.orderNo)
      .toArray()
    for (let data of treeDatas) {
      if (!this.isNull(param.contextmenu)) {
        data.contextmenu = param.contextmenu;
      }
      if (!this.isNull(param.expand)) {
        data.expand = param.expand;
      }
      else {
        data.expand = true;
      }
      data.title = data[keyName];
      if (!this.isNull(param.CId)) {
        data.disabled = param.CId.toString().indexOf(data.CId) > -1 ? false : true;
      }
      data.children = this.getIViewTreeDataPIdTree(data.id, datas, keyName, param);
    }
    return treeDatas
  }

  /**  递归组织iview tree数据
* @param pid
* @param datas
*/
  private getIViewTreeDataPIdTree(pid: number, datas: any[], keyName: string = "Name", param) {
    const childDatas = linq
      .from(datas)
      .where(x => x.PId === pid)
      .orderBy(p => p.orderNo)
      .toArray()
    if (childDatas.length > 0) {
      for (let data of childDatas) {
        if (!this.isNull(param.contextmenu)) {
          data.contextmenu = param.contextmenu;
        }
        if (!this.isNull(param.expand)) {
          data.expand = param.expand;
        }
        else {
          data.expand = true;
        }
        data.title = data[keyName];
        if (!this.isNull(param.CId)) {
          data.disabled = param.CId.toString().indexOf(data.CId) > -1 ? false : true;
        }
        data.children = this.getIViewTreeDataPIdTree(data.id, datas, keyName, param);
      }
    }
    return childDatas
  }

  /**  石太养护组装iview Tree所需数据
   * @param datas
   */
  public getYHIViewTreeDataPId(datas: any[], keyName: string = "Name", param: any = {}) {
    const treeDatas = linq
        .from(datas)
        .where(x => x.pId === 0)
        .orderBy(p => p.orderNo)
        .toArray()
    for (let data of treeDatas) {
      if (!this.isNull(param.expand)) {
        data.expand = param.expand;
      }
      else {
        data.expand = true;
      }
      data.title = data[keyName];
      if (!this.isNull(param.CId)) {
        data.disabled = param.CId.toString().indexOf(data.CId) > -1 ? false : true;
      }
      data.children = this.getYHIViewTreeDataPIdTree(data.id, datas, keyName, param);
    }
    return treeDatas
  }

  /**  石太养护递归组织iview tree数据
   * @param pid
   * @param datas
   */
  private getYHIViewTreeDataPIdTree(pid: number, datas: any[], keyName: string = "Name", param) {
    const childDatas = linq
        .from(datas)
        .where(x => x.pId === pid)
        .orderBy(p => p.orderNo)
        .toArray()
    if (childDatas.length > 0) {
      for (let data of childDatas) {
        if (!this.isNull(param.expand)) {
          data.expand = param.expand;
        }
        else {
          data.expand = true;
        }
        data.title = data[keyName];
        if (!this.isNull(param.CId)) {
          data.disabled = param.CId.toString().indexOf(data.CId) > -1 ? false : true;
        }
        data.children = this.getYHIViewTreeDataPIdTree(data.id, datas, keyName, param);
      }
    }
    return childDatas
  }
  /**
   * 公共使用组件
   * @param {type}
   * @return:
   */
  public commonSel = {
    _this: this,
    // 选择机构/岗位/人员
    comSelUser: function (params) {
      let _this = this._this
      _this.$Modal.confirm({
        width: params.type == 1 ? '600px' : '1000px',
        render: () => {
          return _this.$createElement(baseSelectUi.SelUser, {
            ref: "SelUserUI",
            props: {
              type: params.type,
              unitType: params.unitType,//机构类别 1:公司级机构  2：项目级机构
              subSystemId: params.subSystemId,//子系统Id 用于项目及机构 非项目级机构传0
              selIds: params.selIds,//选中的人员Id 用来反选,
              filterUserId:params.filterUserId //过滤掉的人员Id
            }
          })
        },
        loading: true,
        onOk: () => {
          let param = (<any>_this.$refs.SelUserUI).getSelData()
          params.selCallBack(param);
          _this.$Modal.remove();
        },
        onCancel: () => {
          _this.$Modal.remove();
          params.closeCallBack();
        },
      })
      _this.setivewModalZindexMax()
    },
    comJLXXHSelUser: function (params) {
      let _this = this._this
      _this.$Modal.confirm({
        width: params.type == 1 ? '600px' : '1000px',
        render: () => {
          return _this.$createElement(baseSelectUi.SelJLXXHUser, {
            ref: "SelJLXXHUser",
            props: {
              type: params.type,
              unitType: params.unitType,//机构类别 1:公司级机构  2：项目级机构
              subSystemId: params.subSystemId,//子系统Id 用于项目及机构 非项目级机构传0
              selIds: params.selIds//选中的人员Id 用来反选
            }
          })
        },
        loading: true,
        onOk: () => {
          let param = (<any>_this.$refs.SelJLXXHUser).getSelData()
          params.selCallBack(param);
          _this.$Modal.remove();
        },
        onCancel: () => {
          _this.$Modal.remove();
          params.closeCallBack();
        },
      })
      _this.setivewModalZindexMax()
    },

    // 选择机构/岗位/人员(数据中心选择使用)
    comSelDbCenterUser: function (params) {
      let _this = this._this
      _this.$Modal.confirm({
        width: params.type == 1 ? '600px' : '1000px',
        render: () => {
          return _this.$createElement(baseSelectUi.SelUserDbCenter, {
            ref: "SelUserUI",
            props: {
              type: params.type,
              unitType: params.unitType,//机构类别 1:公司级机构  2：项目级机构
              subSystemId: params.subSystemId,//子系统Id 用于项目及机构 非项目级机构传0
              selIds: params.selIds,//选中的人员Id 用来反选,
              filterUserId:params.filterUserId //过滤掉的人员Id
            }
          })
        },
        loading: true,
        onOk: () => {
          let param = (<any>_this.$refs.SelUserUI).getSelData()
          params.selCallBack(param);
          _this.$Modal.remove();
        },
        onCancel: () => {
          _this.$Modal.remove();
          params.closeCallBack();
        },
      })
      _this.setivewModalZindexMax()
    },

    //新构件弹出
    newSelComponent: function (params) {
      let _this = this._this
      _this.$Modal.confirm({
        width: params.type == 1 ? '800px' : '1200px',
        closable: true,
        render: () => {
          return _this.$createElement(baseSelectUi.newSelComponent, {
            ref: "SelComponentUI",
            props: {
              getComponentApi: _this.isNull(params.getComponentApi) ? undefined : params.getComponentApi,
              type: params.type,        //1：单位工程   2：分项工程(构件)
              Rcode: params.Rcode,      //RId参数
              BIId: params.BIId,          //重组机构Id
              isMulit: params.isMulit,   //是否多选
              NodeType: params.NodeType,    //0:全部 1:桥梁  2：隧道  3：路基  4：路面  5：交安 6-涵洞，7支挡工程，8-排水，9-机电，84-绿化，85-房建，1001-收费站，1002-服务区
            }
          })
        },
        loading: true,
        onOk: () => {
          let param = (<any>_this.$refs.SelComponentUI).getSelData()
          params.selCallBack && params.selCallBack(param);
          _this.$Modal.remove();
        },
        onCancel: () => {
          params.closeCallBack && params.closeCallBack();
          _this.$Modal.remove();
        }
      })
      _this.setivewModalZindexMax()
    },
    // 选择相关方人员
    comSelPersonLabor: function (params) {
      let _this = this._this
      _this.$Modal.confirm({
        width: params.type == 1 ? '600px' : '1000px',
        render: () => {
          return _this.$createElement(baseSelectUi.SelPersonLabor, {
            ref: "SelPersonLaborUI",
            props: {
              type: params.type,
              unitType: params.unitType,//机构类别 1:公司级机构  2：项目级机构
              subSystemId: params.subSystemId,//子系统Id 用于项目及机构 非项目级机构传0
              selIds: params.selIds,//选中的人员Id 用来反选
              uType: params.uType //人员类型 0：全部；1：职工；2：劳务
            }
          })
        },
        loading: true,
        onOk: () => {
          let param = (<any>_this.$refs.SelPersonLaborUI).getSelData()
          params.selCallBack(param);
          _this.$Modal.remove();
        }
      })
      _this.setivewModalZindexMax()
    },
    //新分项工程调用---自由选择
    newSelComponentFree: function (params) {
      let _this = this._this
      _this.$Modal.confirm({
        width: "1000px",
        closable: true,
        render: () => {
          return _this.$createElement(baseSelectUi.newSelComponentFree, {
            ref: "SelComponentFreeUI",
            props: {
              Ids: params.Ids == null ? [] : params.Ids,  //传入已选择ID作为回显
              getComponentApi: _this.isNull(params.getComponentApi) ? undefined : params.getComponentApi,
              Rcode: params.Rcode,      //RId参数
              BIId: params.BIId,          //重组机构Id
              isMulit: params.isMulit,   //是否多选
              NodeType: params.NodeType,    //0:全部 1:桥梁  2：隧道  3：路基  4：路面  5：交安 6-涵洞，7支挡工程，8-排水，9-机电，84-绿化，85-房建，1001-收费站，1002-服务区
            }
          })
        },
        loading: true,
        onOk: () => {
          let param = (<any>_this.$refs.SelComponentFreeUI).getSelData()
          params.selCallBack && params.selCallBack(param);
          _this.$Modal.remove();
        },
        onCancel: () => {
          params.closeCallBack && params.closeCallBack();
          _this.$Modal.remove();
        }
      })
      _this.setivewModalZindexMax()
    },
    // 选择工点
    WorkPlace: (params: { isMulit, Ids, selCallBack }) => {
      let BCId = this.$globalData_Plms.institutioninfor.institutionNameNature
      let width = "500px"
      if (BCId == 'sg') {
        width = params.isMulit ? '800px' : '500px'
      } else {
        width = params.isMulit ? '980px' : '700px'
      }
      this.$Modal.info({
        width: width,
        closable: true,
        render: (h: any) => {
          return h('div', [
            h('div', {
              class: 'ivu-icon ivu-icon-ios-contacts',
              style: { display: 'flex', fontSize: '20px', paddingBottom: '20px' }
            },
              [h('p', {
                style: {
                  fontSize: '18px',
                  marginLeft: '10px'
                }
              }, "工点选择")]
            ),
            this.$createElement(baseSelectUi.WorkPlace, {
              ref: "workPlace",
              props: {
                isMulit: params.isMulit,   //是否多选
                Ids: params.Ids == null ? [] : params.Ids  //传入已选择ID作为回显
              }
            })
          ])
        },
        onOk: () => {
          let param = this.ref("workPlace").getSelectData();
          if (param.length < 1) {
            this.warning("您未选择工点！");
            return
          }
          if (params.selCallBack) {
            params.selCallBack(param);
          }
          this.$Modal.remove();
        },
        onCancel: () => {
          params.Ids = []
        }
      })
      this.setivewModalZindexMax()
    },

  }

  public getElementById(id) {
    return document.getElementById(id) as any
  }

  /**
   * 获取查询构造器
   * @returns
   */
  public getQueryWrapper() {
    return new QueryWrapper();
  }


  /**
   * 获取项目Id
   * @returns
   */
  public getProjectDataId() {
    return this.$globalData_Plms.itemInfo.id;
  }

  public get G_ProjectDataId() {
    return this.$globalData_Plms.itemInfo.id;
  }

  /**
   * 获取根项目Id
   * @returns 
   */
  public getRootProjectId() {
    return this.$globalData_Plms.itemInfo.projectId;
  }

  public get G_ProjectId() {
    if (this.$globalData_Plms.itemInfo.projectId == 14) {
      return this.$globalData_Plms.localUser.enterpriseinfoId
    } else {
      return this.$globalData_Plms.itemInfo.projectId;
    }
  }
  public get G_EnterName() {
    if (this.isNull(this.$globalData_Plms.itemInfo.enterpriseinfoName)) {
      return this.$globalData_Plms.localUser.enterpriseinfoName
    } else {
      return this.$globalData_Plms.itemInfo.enterpriseinfoName;
    }
  }




  /**
   * 获取项目名称
   * @returns
   */
  public getProjectName() {
    return this.$globalData_Plms.itemInfo.subProjectName;
  }

  public get G_ProjectName() {
    return this.$globalData_Plms.itemInfo.subProjectName;
  }

  /**
   * 获取子系统Id
   * @returns
   */
  public getSubSystemId() {
    return this.$globalData_Plms.subSysteminfor.id;
  }


  public get G_SubSystemId() {
    return this.$globalData_Plms.subSysteminfor.id;
  }


  /**
   * 获取线路Id
   * @returns
   */
  public getRoadId() {
    if (this.isNull(this.$globalData_Plms.roadInfo.id)) {
      return 0
    }
    return this.$globalData_Plms.roadInfo.id;
  }
  public get G_RoadId() {
    if (this.isNull(this.$globalData_Plms.roadInfo.id)) {
      return 0
    }
    return this.$globalData_Plms.roadInfo.id;
  }

  /**
   * 获取机构Id
   * @returns
   */
  public getBIID() {
    return this.$globalData_Plms.institutioninfor.id;
  }

  /**
   * 获取机构Id
   * @returns
   */
  public getPBIID() {
    return this.$globalData_Plms.institutioninfor.PId;
  }

  /**
  * 获取机构Id
  * @returns
  */
  public get G_BIId() {
    return this.$globalData_Plms.institutioninfor.id;
  }

  /**
   * 获取机构名称
   * @returns
   */
  public getBNmae() {
    return this.$globalData_Plms.institutioninfor.institutionName;
  }

  /**
   * 获取机构名称
   * @returns
   */
  public get G_BName() {
    return this.$globalData_Plms.institutioninfor.institutionName;
  }




  /**
   * 获取RootBIId
   * @returns 
   */
  public getRootBIId() {
    return this.$globalData_Plms.institutioninfor.RootId;
  }

  /**
   * 机构名称
   * @returns
   */
  public getInstitutionName() {
    return this.$globalData_Plms.institutioninfor.institutionName;
  }

  /**
   * 获取当前机构类型编码
   * @returns
   */
  public getInsClassCode() {
    return this.$globalData_Plms.institutioninfor.institutionNameNature;
  }

  /**
   * 机构性质
   * @returns
   */
  public getInsNature() {
    return this.$globalData_Plms.institutioninfor.institutionNature;
  }

  /**
   * 获取当前用户Id
   * @returns
   */
  public getUserId() {
    return this.$globalData_Plms.localUser.id;
  }

  /**
   * 获取当前用户Id
   */
  public get G_UserId() {
    return this.$globalData_Plms.localUser.id;
  }

  /**
   * 获取用户名称
   * @returns 
   */
  public getUserName() {
    return this.$globalData_Plms.localUser.userName;
  }

  /**
   * 获取用户名称
   */
  public get G_UserName() {
    return this.$globalData_Plms.localUser.userName;
  }

  /**
   * 获取用户真实名称
   * @returns 
   */
  public getUserTrueName() {
    return this.$globalData_Plms.localUser.userTrueName;
  }


  /**
   * 获取用户真实名称
   * @returns 
   */
  public get G_UserTrueName() {
    return this.$globalData_Plms.localUser.userTrueName;
  }

  /**
   * 数组根据时间排序
   * @param property 属性名
   * @param bol 正序 true 倒序 false
   * @returns 
   * @param 使用：arr.sort(this.sortList('时间字段',true))
   * @author: Yin
   */
  public sortList(property: string, bol: boolean = false) {
    return function (a, b) {
      let v1 = a[property]
      let v2 = b[property]
      if (bol) {
        // 升序
        return Date.parse(v1) - Date.parse(v2)
      } else {
        // 降序
        return Date.parse(v2) - Date.parse(v1)
      }
    }
  }

  /**
   * 获取当前时间并打印
   * @returns
   */
  public getCurrentTime(format = "yyyy-MM-dd hh:mm:ss") {
    const dateTime = new Date();
    return this.ForMatDate(dateTime, format);
  }
  /**
    * @description:
    * @param {*} format   格式化
    * @return {*}
    * @author: pangting
    */
  public getCurrentDate(format = "yyyy-MM-dd") {
    const dateTime = new Date();
    return this.ForMatDate(dateTime, format);
  }

  /**
   * 小时加减运算
   * @param date
   * @param hour
   */
  public addHour(date, hour = 0) {
    const dateTime = date == '' ? new Date() : new Date(date);
    dateTime.setHours(dateTime.getHours() + hour);
    return this.ForMatDate(dateTime, 'yyyy-MM-dd hh:mm');
  }
  /**
 * 天数加减运算
 * @param date
 * @param day
 */
  public addDay(date, day = 0) {
    const dateTime = date == '' ? new Date() : new Date(date);
    dateTime.setDate(dateTime.getDate() + day);
    return this.ForMatDate(dateTime, 'yyyy-MM-dd');
  }

  /**
   * 天数加减运算
   * @param date
   * @param day
   */
  public addDayXM(date, day = 0) {
    const dateTime = date == '' ? new Date() : new Date(date);
    dateTime.setDate(dateTime.getDate() + day);
    return this.ForMatDate(dateTime, 'yyyy-MM-dd hh:mm');
  }
  public addMinute(date, minute = 0) {
    const dateTime = date == '' ? new Date() : new Date(date);
    dateTime.setMinutes(dateTime.getMinutes() + minute);
    return this.ForMatDate(dateTime, 'yyyy-MM-dd hh:mm');
  }
  /**
   * 获取前几天或后几天的日期
   * @param day
   */
  public getBeforeOrAfterDate(day) {
    let today = new Date();
    let targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
    today.setTime(targetday_milliseconds);
    let tYear = today.getFullYear();
    let tMonth = today.getMonth();
    let tDate = today.getDate();
    tMonth = this.doHandleMonth(tMonth + 1);
    tDate = this.doHandleMonth(tDate);
    return tYear + "-" + tMonth + "-" + tDate;
  }
  doHandleMonth(month) {
    let m = month;
    if (month.toString().length == 1) {
      m = "0" + month;
    }
    return m;
  }
  /**
   * @description:
   * @param {*} format   获取星期几
   * @return {*}
   * @author: pangting
   */
  public getWeekDate(dateTime = new Date()) {
    let day = dateTime.getDay();
    let weeks = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
    let week = weeks[day];
    return week;
  }
  /**
     * 对象深复制
     * @param obj
     * @returns
     */
  fromJS(obj): any {
    return fromJS(obj).toJS();
  }
  /**
   * 获取公共字段项
   * @param dkey  字典key
   * @returns
   */
  public async GetPublicDictionary(dkey: string) {
    let apiResult = await this.dicbusinesstypeoptionApi.getDicOptions({ typeCode: dkey });
    const benchmarkTypes: any[] = this.parseApiResult(apiResult);
    return benchmarkTypes.map(item => { return { value: item.optionCode, text: item.optionValue, describe: item.optionDesc, id: item.id } });
  }
  //计算日期之间的周末天数
  public countingWorkingDays(startDate, endDate) {
    // 校验参数
    if (!startDate || !endDate) {
      return 0
    }
    var daysNum = 0;
    var startYearMonthDayStr = startDate.split(" ")[0];
    var endYearMonthDayStr = endDate.split(" ")[0];
    // 解析字符串
    var startYear = startDate.match(/(\d{4})-\d{2}-\d{2}/)[1];
    var startMonth = startDate.match(/\d{4}-(\d{2})-\d{2}/)[1];
    var startDay = startDate.match(/\d{4}-\d{2}-(\d{2})/)[1];
    var startHour = startDate.match(/(\d{1,2}):\d{1,2}/)[1];
    var startMinutes = startDate.match(/\d{1,2}:(\d{1,2})/)[1];
    var startTime = new Date();
    startTime.setFullYear(startYear);
    startTime.setMonth(startMonth - 1);
    startTime.setDate(startDay);
    startTime.setHours(startHour);
    startTime.setMinutes(startMinutes);
    startTime.setSeconds(0);
    startTime.setMilliseconds(0);
    var endYear = endDate.match(/(\d{4})-\d{2}-\d{2}/)[1];
    var endMonth = endDate.match(/\d{4}-(\d{2})-\d{2}/)[1];
    var endDay = endDate.match(/\d{4}-\d{2}-(\d{2})/)[1];
    var endHour = endDate.match(/(\d{1,2}):\d{1,2}/)[1];
    var endMinutes = endDate.match(/\d{1,2}:(\d{1,2})/)[1];
    var endTime = new Date();
    endTime.setFullYear(endYear);
    endTime.setMonth(endMonth - 1);
    endTime.setDate(endDay);
    endTime.setHours(endHour);
    endTime.setMinutes(endMinutes);
    endTime.setSeconds(0);
    endTime.setMilliseconds(0);
    var fullDayTime = 1000 * 60 * 60 * 24;
    var startTime1200 = new Date(startTime.valueOf())
    startTime1200.setHours(12);
    startTime1200.setMinutes(0o0);
    var endTime1200 = new Date(endTime.valueOf())
    endTime1200.setHours(12);
    endTime1200.setMinutes(0o0);
    var addTime = startTime1200.getTime();
    // 只计算跨天
    if (startYearMonthDayStr != endYearMonthDayStr) {

      while (addTime <= endTime1200.getTime()) {
        var currentDate = new Date(addTime);
        var day = currentDate.getDay();
        if (day == 6 || day == 0) {
          daysNum++
        }
        addTime += fullDayTime;
      }
      return daysNum
    } else {
      return daysNum;
    }
  }
  // 获得两日期之间的天数  
  public getDays(startDate, endDate) {
    const sDate = Date.parse(startDate)
    const eDate = Date.parse(endDate)
    if (sDate > eDate) {
      return 0
    }
    if (sDate === eDate) {
      return 1
    }
    const days = (eDate - sDate) / (1 * 24 * 60 * 60 * 1000)
    return days

  }
  /**
     * 日期比较方法
     * @param {String} dateStr1 第一个日期字符串（如"2024-07-06 00:00:00"）
     * @param {String} dateStr2 第二个日期字符串（如"2024-06-30"）
     * @returns {Number} 比较结果：1（dateStr1 > dateStr2）、0（相等）、-1（dateStr1 < dateStr2）、null（日期格式错误）
     */
   public compareDateStrings(dateStr1, dateStr2) {
      // 1. 将日期字符串转换为Date对象
      const date1 = new Date(dateStr1);
      const date2 = new Date(dateStr2);

      // 2. 校验日期是否有效（避免Invalid Date）
      if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
        console.error('日期格式错误，请检查输入的日期字符串');
        return null;
      }

      // 3. 获取时间戳（毫秒数）进行比较
      const time1 = date1.getTime();
      const time2 = date2.getTime();

      if (time1 > time2) {
        return 1; // 第一个日期更大（更晚）
      } else if (time1 < time2) {
        return -1; // 第一个日期更小（更早）
      } else {
        return 0; // 两个日期相等
      }
    }

  /**
   * 获取window对象
   * @returns 
   */
  getWindow() {
    return (window as any);
  }


  //#region 流程相关功能

  /**
   * 发起流程
   * @param businessKey 
   * @param title 
   * @param abstracts 
   * @returns 
   */
  async sendFlow(businessKey: string, IsRepeat: number, title: string, abstracts: Array<{ Title: string, Content: string }>, FlowParams: any = {}) {
    if (this.isNull(this.linkParam.moduleParams)) {
      this.warning("菜单未配置流程标识，请配置后重试");
      return false;
    }

    return await this.sendFlowByFlowCode(this.linkParam.moduleParams, businessKey, title, abstracts, IsRepeat, FlowParams);
  }

  /**
   * 发起流程
   * @param flowCode 流程编码
   * @param businessKey 业务Key
   * @param title 标题
   * @param abstracts 摘要
   * @returns 
   */
  async sendFlowByFlowCode(flowCode: string, businessKey: string, title: string, abstracts: Array<{ Title: string, Content: string }>, IsRepeat: number, FlowParams: any = {}) {
    if (this.isNull(flowCode)) {
      this.warning("未传递流程编码");
      return false;
    }
    let row = await this.getActReFlow(flowCode);
    let data = {
      flowKey: row.ActKey, // 流程key（必传）
      UserId: this.getUserId(),  // 发起人Id (必传)
      UserName: this.getUserTrueName(), // 发起人名称 (必传)
      ProjectId: this.getProjectDataId(), // 项目Id
      ProjectName: this.getProjectName(), // 项目名称
      BIId: this.getBIID(), // 机构Id
      BName: this.getInstitutionName(), // 机构名称
      FlowCode: row.FlowCode, // 流程编码
      FlowTypeNo: row.FlowTypeNo, // 流程类别编码
      BusinessType: row.FlowTypeName, // 业务类型
      BusinessKey: businessKey,   // 业务Key
      Title: title, // 标题
      // 摘要
      Abstract: JSON.stringify(abstracts),
      // 发起时间
      SponsorTime: this.getCurrentDate("yyyy-MM-dd hh:mm:ss"),
      IsRepeat: IsRepeat,  //区分是否是二次提交
      FlowParams: FlowParams
    };

    let result = await this.flowApi.processInit(data);
    if (result.code == 200) {
      sessionStorage.setItem("ProcessInstanceId","")
      sessionStorage.setItem("ProcessInstanceId",result.data.ProcessInstanceId)
      return true;
    }
    return false;
  }

  /**
     * 获取Flow对象信息
     * @returns 
     */
  async getActReFlow(flowCode) {
    const apiResult = await this.base_actReFlowApi.getEntityByFilter(this.getQueryWrapper().select(["Id", "FlowName", "FlowCode", "DetailPageUrl", "Description"
      , "FlowTypeId", "FlowTypeName", "LastUpdateUserId", "LastUpdateUserName", "LastUpdateTime", "ActKey", "FlowTypeNo"]).
      eq("ProjectId", this.getProjectDataId() > 10000 ? 104 : this.getProjectDataId()).eq("FlowCode", flowCode));
    return this.parseApiResult(apiResult);
  }

  async sendFlowTwo(flowCode: string, businessKey: string, title: string, abstracts: Array<{ Title: string, Content: string }>, IsRepeat: number, FlowParams: any = {}) {
    if (this.isNull(flowCode)) {
      this.warning("未传递流程编码");
      return false;
    }

    let row = await this.getActReFlow(flowCode);
    let data = {
      flowKey: row.ActKey, // 流程key（必传）
      UserId: this.getUserId(),  // 发起人Id (必传)
      UserName: this.getUserTrueName(), // 发起人名称 (必传)
      ProjectId: this.getProjectDataId(), // 项目Id
      ProjectName: this.getProjectName(), // 项目名称
      BIId: this.getBIID(), // 机构Id
      BName: this.getInstitutionName(), // 机构名称
      FlowCode: row.FlowCode, // 流程编码
      FlowTypeNo: row.FlowTypeNo, // 流程类别编码
      BusinessType: row.FlowTypeName, // 业务类型
      BusinessKey: businessKey,   // 业务Key
      Title: title, // 标题
      // 摘要
      Abstract: JSON.stringify(abstracts),
      // 发起时间
      SponsorTime: this.getCurrentDate("yyyy-MM-dd hh:mm:ss"),
      IsRepeat: IsRepeat,  //区分是否是二次提交
      FlowParams: FlowParams
    };

    let result = await this.flowApi.processInit(data);
    if (result.code == 200) {
      sessionStorage.setItem("ProcessInstanceId","")
      sessionStorage.setItem("ProcessInstanceId",result.data.ProcessInstanceId)
      return true;
    }
    return false;
  }


  async getJLAndHt() {
    //初始化表头信息；
    let res = await this.institutioninforBaseApi.getJLInstitutionin(this.$globalData_Plms.institutioninfor.id);
    if (res.code == 200) {
      return res.data;
    }
    return null
  }



  mymethod(birthday) {//根据日期算年龄
    if (birthday) {
      birthday = birthday.split('-');
      // 新建日期对象
      let date = new Date();
      // 今天日期，数组，同 birthday
      let today = [date.getFullYear(), date.getMonth() + 1, date.getDate()];
      // 分别计算年月日差值
      let age = today.map((val, index) => {
        return val - birthday[index]
      })
      // 当天数为负数时，月减 1，天数加上月总天数
      if (age[2] < 0) {
        // 简单获取上个月总天数的方法，不会错
        let lastMonth = new Date(today[0], today[1], 0)
        age[1]--
        age[2] += lastMonth.getDate()
      }
      // 当月数为负数时，年减 1，月数加上 12
      if (age[1] < 0) {
        age[0]--
        age[1] += 12
      }
      // console.log(age[0]+'岁'+age[1]+'月'+age[2]+'天');
      return age[0];
    } else {
      return "";
    }
  }


  getOssContentType(fileName) {
    if (fileName.indexOf(".bmp") > -1) {
      return "image/bmp";
    }
    if (fileName.indexOf(".gif") > -1) {
      return "image/gif";
    }
    if (fileName.indexOf(".jpeg") > -1 ||
      fileName.indexOf(".jpg") > -1 ||
      fileName.indexOf(".png") > -1) {
      return "image/jpg";
    }
    if (fileName.indexOf(".html") > -1) {
      return "text/html";
    }
    if (fileName.indexOf(".txt") > -1) {
      return "text/plain";
    }
    if (fileName.indexOf(".vsd") > -1) {
      return "application/vnd.visio";
    }
    if (fileName.indexOf(".pptx") > -1 ||
      fileName.indexOf(".ppt") > -1) {
      return "application/vnd.ms-powerpoint";
    }
    if (fileName.indexOf(".docx") > -1 ||
      fileName.indexOf(".doc") > -1) {
      return "application/msword";
    }
    if (fileName.indexOf(".xls") > -1 ||
      fileName.indexOf(".xlsx") > -1 ||
      fileName.indexOf(".xla") > -1) {
      return "application/vnd.ms-excel";
    }

    if (fileName.indexOf(".xml") > -1) {
      return "text/xml";
    }
    if (fileName.indexOf(".pdf") > -1) {
      return "application/pdf";
    }
    if (fileName.indexOf(".zip") > -1) {
      return "application/zip";
    }
    if (fileName.indexOf(".tar") > -1) {
      return "application/x-tar";
    }
    if (fileName.indexOf(".avi") > -1) {
      return "video/avi";
    }
    if (fileName.indexOf(".mp4") > -1) {
      return "video/mp4";
    }
    if (fileName.indexOf(".mp3") > -1) {
      return "audio/mp3";
    }

    return "application/octet-stream";

  }

  /**
   * //微信小程序消息推送
   * @param UId 接收人Id
   * @param Business 业务描述
   * @param MsgContent 消息主题
   * @param Miniprogram 跳转页面
   * @param Applicant
   * @returns
   */
  sendWeChartMsgToAppoint(UId, Applicant, Business, MsgContent, Miniprogram = "") {
    if (this.isNull(UId)) {
      return;
    }
    let uIds = []
    if (typeof (UId) == "number") {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      uIds = [UId]
    } else {
      uIds = UId.split(",")
    }
    let messageList: any = []
    uIds.forEach((item, index) => {
      if (!this.isNull(item)) {
        messageList.push({
          // Id: 0,
          projectId: this.$globalData_Plms.itemInfo.id,
          // roadId: this.$globalData_Plms.roadInfo.id,
          siId: 0,
          suId: 0,
          riId: 0,
          ruId: parseInt(item),
          business: Business,
          caption: Business,
          msgContent: MsgContent,
          readRecord: this.$globalData_Plms.itemInfo.subProjectName,
          createTime: this.getCurrentTime(),
          transforMode: "WeChat",
          status: 1,
          sendType: !this.isNull(Miniprogram) ? 0 : 1,
          miniProgram: Miniprogram,
          // sendName: this.$globalData_Plms.localUser.userTrueName
          sendName: this.isNull(Applicant) ? this.$globalData_Plms.localUser.userTrueName : Applicant
        })
      }
    });
    this.shortmessagesApi.savesList(messageList)
  }
  /**
   * 企业微信消息推送
   * @param UId 接收人Id
   * @param Business 业务描述
   * @param MsgContent 消息主题
   * @param Miniprogram 跳转页面
   * @returns
   */
  sendWeComMsgToAppoint(UId, Business, MsgContent, Miniprogram = "",Applicant="") {
    if (this.isNull(UId)) {
      return;
    }
    let uIds = []
    if (typeof (UId) == "number") {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      uIds = [UId]
    } else {
      uIds = UId.split(",")
    }
    let messageList: any = []
    uIds.forEach((item, index) => {
      if (!this.isNull(item)) {
        messageList.push({
          // Id: 0,
          projectId: this.$globalData_Plms.itemInfo.id,
          // roadId: this.$globalData_Plms.roadInfo.id,
          siId: 0,
          suId: 0,
          riId: 0,
          ruId: parseInt(item),
          business: Business,
          caption: Business,
          msgContent: MsgContent,
          createTime: this.getCurrentTime(),
          transforMode: "WeCom",
          status: 1,
          sendType: !this.isNull(Miniprogram) ? 0 : 1,
          miniProgram: Miniprogram,
          // sendName: this.$globalData_Plms.localUser.userTrueName,
          sendName: this.isNull(Applicant) ? this.$globalData_Plms.localUser.userTrueName : Applicant,
          readRecord: this.$globalData_Plms.itemInfo.subProjectName,
        })
      }
    });
    this.shortmessagesApi.saveQYWXList(messageList)
  }
  //代办信息短信推送

  sendMobileMsgToAppoint(UId, Business, MsgContent, Miniprogram = "",Applicant="") {
    if (this.isNull(UId)) {
      return;
    }
    let uIds = []
    if (typeof (UId) == "number") {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      uIds = [UId]
    } else {
      uIds = UId.split(",")
    }
    let messageList: any = []
    uIds.forEach((item, index) => {
      if (!this.isNull(item)) {
        messageList.push({
          // Id: 0,
          projectId: this.$globalData_Plms.itemInfo.id,
          // roadId: this.$globalData_Plms.roadInfo.id,
          siId: 0,
          suId: 0,
          riId: 0,
          ruId: parseInt(item),
          business: Business,
          caption: Business,
          msgContent: MsgContent,
          createTime: this.getCurrentTime(),
          transforMode: "Mobile",
          status: 1,
          sendType: !this.isNull(Miniprogram) ? 0 : 1,
          miniProgram: Miniprogram,
          // sendName: this.$globalData_Plms.localUser.userTrueName,
          sendName: this.isNull(Applicant) ? this.$globalData_Plms.localUser.userTrueName : Applicant,
          readRecord: this.$globalData_Plms.itemInfo.subProjectName,
        })
      }
    });
    this.shortmessagesApi.saveMobileList(messageList)
  }


  async getCAData(content) {
    let base64encode1 = this.base64encode('hebeijtsjy:hebeijtsjy@2021');
    let res: any = await request("https://cloud.tecshield.com/auth/oauth/token", {
      method: "POST",
      params: { grant_type: 'client_credentials', scope: 'all' },
      headers: {
        'Authorization': 'Basic ' + base64encode1
      }
    })
    return await this.getCAAuthcode(2, 123456, content, res.access_token);
  }


  /**
   * 获取授权码
   * @param type
   * @param password
   * @param content
   */
  async getCAAuthcode(type, password, content, accessToken) {
    let res = await request("https://cloud.tecshield.com/cert/api/authcode", {
      method: "POST",
      params: { certSubjectId: '弓社强679443', type: 2, data: password },
      headers: {
        'Authorization': 'Bearer ' + accessToken
      }
    })
    return await this.getCASign(content, res.data.authcode, accessToken);
  }

  /**
   * 获取签名
   * @param content
   * @param authcode
   * @param accessToken
   */
  async getCASign(content, authcode, accessToken) {
    let base64encode1 = this.base64encode(content);
    let res = await request("https://cloud.tecshield.com/signature/api/signSeal", {
      method: "POST",
      params: { source: base64encode1, sealSn: 'Seal1419563600781398016', authCode: authcode },
      headers: {
        'Authorization': 'Bearer ' + accessToken
      }
    })
    return res.data;
  }
  //查询分部负责人和驻地办监理；
  async getfbLeader() {
    let res = await this.institutioninforelationBaseApi.getfbLeader({ iid: this.$globalData_Plms.institutioninfor.id })
    if (res.code == 200) {
      let newObj: any = {}
      newObj.zdjl = res.data.zdjl ? res.data.zdjl : 0;
      newObj.fbfzr = res.data.fbfzr ? res.data.fbfzr : 0;
      return newObj;
    }
  }
  // 查询天气
  async getWeatherInfo(city) {
    let res: any = await request(`weather/v3/weather/now.json?key=SRPo1Tavvf_QR5Gq8&location=${city}&language=zh-Hans&unit=c`)
    try {
      return res.results[0].now
    } catch (error) {
      return null
    }

  }
  //   public async getOssUrlByFile(file) {
  //     let filePath = await this.getSignatureUrl("/" +"QT" + file.Catalog + "/" + this.ForMatDate(new Date(file.CreateTime), 'yyyyMMdd') + "/" + file.Name)
  //     return filePath
  //   }
  /**
   * 获取文件安全路径
   * @param fileName
   * @param config
   * @returns
   */
    public async getOssUrlByFileName(fileName,config:{region:string,bucket:string}){
      return await getSignatureUrl(fileName,config);
    }
  //#endregion

  /**
 * 非法时间置空
 * @param list 数据列表
 * @param val 替换的值
 * @param params 单个数据中需要置空的字段名
 */
  illegalTimeNull(list, val = "", ...params) {
    if (list.length > 0) {
      list.forEach((item) => {
        params.forEach((param) => {
          if (!item[param]) {
            item[param] = val;
          } else if (item[param].substr(0, 1) === "0") {
            item[param] = val;
          } else if (item[param].substr(0, 4) === "1900") {
            item[param] = val;
          }
        });
      });
    }
  }

  //#region  正则验证
  commonReg = {
    mobileNo: (value) => {
      return new RegExp("^1[356789]\\d{9}$").test(value)
    },
    idCardNo: (value) => {
      return /^((1[1-5])|(2[1-3])|(3[1-7])|(4[1-6])|(5[0-4])|(6[1-5])|[7-9]1)\d{4}(19|20|21)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(value)
    }
  }

  // @ts-ignore
  async getuserIsCASign() {
    //1，获取用户信息
    let data: any = await this.usersignatureBaseApi.getDataById(this.getUserId())
    if (data.code == 200) {
      // //测试时使用、发布生产环境时放开
      // if (this.isNull(data.data)){
      //   let newObj:any ={
      //     signKey:"Seal1663370849058074624",
      //     signCertificate:"刘颖卉282217"
      //   }
      //   data.data = newObj
      // }
      if (this.isNull(data.data) || this.isNull(data.data.signKey)) {
        this.$Modal.error({
          width: 380,  //宽度在300~380之间
          okText: "关闭",
          render: (h: any) => {
            return h("div", {
              style: "text-align: center;",
            }, [
              h("p", { style: "line-height:35px;" }, "该账号还未申请签字证书"),
              h("p", { style: "margin-bottom:20px" }, "扫描二维码立即申请,申请成功后请联系管理员！"),
              h("img", {
                attrs: {
                  src: "data:image/jpg;base64,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",
                },
                style: "width:160px;",
                on: {

                }
              })
            ]);
          },
        });
        return -2;
      } else {
        return 1;
      }
    }
  }
  /**
  * @description: 打开批量打印窗口
  * @param {any} param {Token:"文件token",TempToken:"模板token(无模板可不传)",readOnly:false,taoHongToken:"套红模板token(无模板可不传)"} 
  * @return {*}
  * @author: pangting
  */
  BatchPrintOpen(FileTokens: any[] = []) {
    if (FileTokens.length < 1) {
      this.$Message.error("无需要打印的文件");
      return
    }
    var ws1 = new WebSocket('ws://127.0.0.1:32019/print');
    ws1.onopen = () => {
      console.log('ws连接状态：' + ws1.readyState);

      let rdata = {
        Bearer: sessionStorage.getItem("token"),
        Tokens: FileTokens
      }
      //连接成功则发送一个数据
      ws1.send(JSON.stringify(rdata))
    }
    ws1.onmessage = (data) => {
      console.log('接收到来自服务器的消息：');
      console.log(data);
      //完成通信后关闭WebSocket连接
    }
    ws1.onerror = (data) => {
      window.open("NewViewPrintReport://")
      this.$Modal.info({
        width: 560,
        closable: false,
        okText: "关闭",
        render: (h: any) => {
          return h('div', {
            style: {
              "padding-top": "30px",
              'text-align': 'center'
            }
          }, [
            h('div', {
              class: '',
              style: `font-size: 17px;color: #929292;margin-bottom: 10px;`
            }, "尚未安装批量打印插件"),
            h('div', {
              class: 'nv-flex',
              style: `justify-content: space-between;`
            }, [h('div', {
              class: '',
              style: `border: 2px solid #68acf4;
                              padding: 5px 15px;
                              font-weight: bold;
                              font-size: 16px;
                              border-radius: 4px;
                              display: inline-block;`,
              on: {
                click: () => {
                  if (this.getCPU() != undefined) {
                    window.location.href = `/static/BatchPrint/print_${this.getCPU()}.exe`;
                    let runSocket = () => {
                      var wst = new WebSocket('ws://127.0.0.1:32019/print');
                      wst.onopen = (msg) => {
                        console.log("收到", msg);
                        this.$Modal.remove()
                        let rdata = {
                          Bearer: sessionStorage.getItem("token"),
                          Tokens: FileTokens
                        }
                        //连接成功则发送一个数据
                        wst.send(JSON.stringify(rdata))
                      }
                      wst.onerror = () => {
                        runSocket()
                      }
                    }
                    runSocket()
                  }
                }
              }
            }, [
              h("Icon", {
                props: {
                  type: "md-download",
                  color: "#68acf4",
                  size: 20
                }
              }),
              h('a', {}, this.getCPU() != undefined ? "下载批量打印程序" : "暂不支持此系统")
            ]),])

          ])
        },
        onOk: () => {
        },
        onCancel: () => {
        }
      })
      let runSocketOpen = () => {
        var wst = new WebSocket('ws://127.0.0.1:32019/print');
        wst.onopen = (msg) => {
          console.log("收到", msg);
          this.$Modal.remove()

          let rdata = {
            Bearer: sessionStorage.getItem("token"),
            Tokens: FileTokens
          }
          //连接成功则发送一个数据
          wst.send(JSON.stringify(rdata))
        }
        wst.onerror = () => {
          runSocketOpen()
        }
      }
      runSocketOpen()
    }

  }
  //获取电脑系统位数
  getCPU() {
    let agent = navigator.userAgent.toLowerCase();
    if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0) {
      return 32
    } else if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
      return 64
    }
    return undefined
  }
  /**
   * 转换CronExpression表达式
   * @param loopTime
   * @param loopCycle
   */
  getCronExpression(loopTime, loopCycle) {
    let loopDay = loopCycle == 1 ? "*" : "1/" + loopCycle;
    let split: any = loopTime.split(":");
    let cronStr = split[2] + " " + split[1] + " " + split[0] + " " + loopDay + " * ?";
    return cronStr;
  }

  /**
    * 将数组转为IView下拉框数据
    * @param source 源数据
    * @param text text对应字段
    * @param value value对应字段
    * @returns 
    */
  public parseIViewOptions(source: any[], text: string, value: string): any[] {
    return source.map(e => {
      return {
        text: e[text],
        value: e[value]
      }
    })
  }




  /**延迟Loading展示
   * 返回结果为promise中的返回结果
   */
  delayLoading(config: {
    dom?: HTMLElement
  }, ...promiseList: Promise<any>[]): Promise<any> {
    // 生成一个LoadingDom
    let createLoadingDom = () => {
      let spinDom = document.createElement("div");
      spinDom.className = "ivu-spin ivu-spin-default ivu-spin-fix";
      let spinMainDom = document.createElement("div");
      spinMainDom.className = "ivu-spin-main";
      spinDom.appendChild(spinMainDom);
      let spinDotDom = document.createElement("span");
      spinDotDom.className = "ivu-spin-dot";
      spinMainDom.appendChild(spinDotDom);
      return spinDom;
    };

    // 判断是否为定位元素
    let isPosition = (prePosition) => {
      return prePosition !== "absolute" &&
        prePosition !== "relative" &&
        prePosition !== "fixed"
    }

    // 之前的定位属性值
    let prePosition: string;
    let spinDom: HTMLElement;
    if (config.dom) {
      prePosition = config.dom.style.position;
      if (isPosition(prePosition)) {
        config.dom.style.position = "relative";
      }
      spinDom = createLoadingDom();
      config.dom.appendChild(spinDom);
    } else {
      console.error('[Newview Error]: dom is undefined')
    }
    return new Promise((resolve) => {
      Promise.all(promiseList).then((res) => {
        if (res.length === 1) {
          resolve(res[0])
        } else {
          resolve(res);
        }
        if (config.dom) {
          config.dom.style.position = prePosition;
          config.dom.removeChild(spinDom);
        }
      });
    });
  }

  //#endregion
}


